import React, { useEffect, useState, useMemo, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputMask } from "primereact/inputmask";
import { Checkbox } from "primereact/checkbox";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Card } from "primereact/card";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileUpload } from "primereact/fileupload";

import { Accordion, AccordionTab } from "primereact/accordion";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { format } from "date-fns";

import Webcam from "react-webcam";

import "primeicons/primeicons.css";
import "./style.css";

import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaMapPin,
  FaCity,
  FaCalendarPlus,
  FaIdCard,
  FaList,
  FaHistory,
  FaTag,
  FaSearch,
  FaFileAlt,
  FaImage,
  FaDollarSign,
  FaEye,
  FaUserMd,
  FaExclamationTriangle,
  FaHeartbeat,
  FaChartPie,
  FaChartLine,
  FaBuilding,
  FaCalendarAlt,
  FaPaperclip,
  FaCalendarCheck,
  FaMoneyBillAlt,
  FaGlobeAmericas,
  FaCheckCircle,
  FaUser,
  FaCashRegister,
  FaShoppingCart,
  FaPlusCircle,
  FaMinusCircle,
  FaUserFriends,
  FaChartBar,
  FaFileMedical,
  FaCreditCard,
  FaWallet,
  FaMoneyBillWave,
  FaClock,
  FaMailBulk,
  FaTooth,
} from "react-icons/fa";

const Pacientes = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pacientes, setPacientes] = useState([]);
  const [visualizacaoResumida, setVisualizacaoResumida] = useState(false);
  const [visibleNovoPaciente, setVisibleNovoPaciente] = useState(false);
  const [visibleEditar, setVisibleEditar] = useState(false);
  const [pacienteEditando, setPacienteEditando] = useState([]);

  const [visibleCarteira, setVisibleCarteira] = useState(false);
  const [visibleFinanceiro, setVisibleFinanceiro] = useState(false);
  const [visibleAnexos, setVisibleAnexos] = useState(false);
  const [visibleFicha, setVisibleFicha] = useState(false);
  const [visibleAdicionarSaldo, setVisibleAdicionarSaldo] = useState(false);

  const [itensExpandidos, setItensExpandidos] = useState([]);

  const [saldo, setSaldo] = useState("");
  const [valorAdicionar, setValorAdicionar] = useState("");

  // ==========================================================================
  // ESTADOS DOS DENTES SELECIONADOS (AGORA APENAS PARA VISUALIZAÇÃO)
  // ==========================================================================
  const [tipoDente, setTipoDente] = useState("adulto");
  const [historicoDentesMap, setHistoricoDentesMap] = useState({});

  // Estado para controlar o tamanho da tela
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Adicione este estado junto com os outros estados do seu componente
  const [secoesExpandidas, setSecoesExpandidas] = useState([]);

  // Função para alternar seções (igual à do histórico)
  const alternarSecao = (secaoId) => {
    if (secoesExpandidas.includes(secaoId)) {
      setSecoesExpandidas(secoesExpandidas.filter((id) => id !== secaoId));
    } else {
      setSecoesExpandidas([...secoesExpandidas, secaoId]);
    }
  };

  //Cadastro
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [rg, setRg] = useState("");
  const [dtNascimento, setDtNascimento] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [cep, setCep] = useState("");
  const [ativo, setAtivo] = useState(true);

  // Estados para os dialogs de confirmação
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  // Estados para controle dos dialogs
  const [visibleCaixa, setVisibleCaixa] = useState(false);
  const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
  const [tipoPagamento, setTipoPagamento] = useState("");
  const [acrescimo, setAcrescimo] = useState("");
  const [desconto, setDesconto] = useState("");

  //Filtro
  const [mostrarFiltroPaciente, setMostrarFiltroPaciente] = useState(false);

  //Filtro
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCpf, setFiltroCpf] = useState("");
  const [filtroTelefone, setFiltroTelefone] = useState("");
  const [filtroEmail, setFiltroEmail] = useState("");

  const [visibleHistorico, setVisibleHistorico] = useState(false);
  const [pacienteEscolhido, setPacienteEscolhido] = useState([]);
  const [pacienteCaixa, setPacienteCaixa] = useState([]);

  //Arquivo
  const webcamRef = useRef(null);
  const [fotoBase64, setFotoBase64] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [erros, setErros] = useState("");
  const [observacaoFoto, setObservacaoFoto] = useState("");
  const [tipoCamera, setTipoCamera] = useState("environment");
  const [fotosPaciente, setFotosPaciente] = useState([]);
  const [fotoVisualizando, setFotoVisualizando] = useState(null);

  //Nova Agenda
  const [visibleAdicionar, setVisibleAdicionar] = useState(false);
  const [data, setData] = useState("");
  const [hora, setHora] = useState("");
  const [profissional, setProfissional] = useState("");
  const [servico, setServico] = useState("");

  //Formas De Pagamento
  const [empresa, setEmpresa] = useState("");
  const [empresas, setEmpresas] = useState(null);
  const [empresasOptions, setEmpresasOptions] = useState([]);
  const [formaPagamento, setFormaPagamento] = useState(null);
  const [formasPagamento, setFormasPagamento] = useState(null);
  const [carregandoEmpresas, setCarregandoEmpresas] = useState(false);

  const [dadosCompletos, setDadosCompletos] = useState({
    empresas: [],
    profissionais: [],
    servicos: [],
    datas_atendimento: [],
    horarios: [],
    agendamentos_existentes: [],
  });

  const [profissionaisFiltrados, setProfissionaisFiltrados] = useState([]);
  const [datasDisponiveis, setDatasDisponiveis] = useState([]);
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);
  const [servicosFiltrados, setServicosFiltrados] = useState([]);

  useEffect(() => {
    fetchPacientes();
  }, []);

  // filtrados e ordenados
  const pacientesFiltrados = useMemo(() => {
    return pacientes.filter((paciente) => {
      // Verifica filtro de nome (se filtroNome não estiver vazio)
      const nomeMatch =
        !filtroNome ||
        paciente.nome?.toLowerCase().includes(filtroNome.toLowerCase());

      // Verifica filtro de CPF (se filtroCpf não estiver vazio)
      const cpfMatch =
        !filtroCpf ||
        paciente.cpf?.toLowerCase().includes(filtroCpf.toLowerCase());

      // Verifica filtro de telefone (se filtroTelefone não estiver vazio)
      const telefoneMatch =
        !filtroTelefone ||
        paciente.telefone?.toLowerCase().includes(filtroTelefone.toLowerCase());

      // Verifica filtro de email (se filtroEmail não estiver vazio)
      const emailMatch =
        !filtroEmail ||
        paciente.email?.toLowerCase().includes(filtroEmail.toLowerCase());

      // Retorna true apenas se TODOS os filtros ativos corresponderem
      return nomeMatch && cpfMatch && telefoneMatch && emailMatch;
    });
  }, [pacientes, filtroNome, filtroCpf, filtroTelefone, filtroEmail]);

  // Buscar empresas ativas
  const fetchEmpresas = async () => {
    setCarregandoEmpresas(true);
    try {
      if (!user?.token) return;

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          // CORREÇÃO: Preencher o estado empresas (que é usado no dropdown)
          setEmpresas(data.data); // Isso que estava faltando!

          const options = data.data.map((empresa) => ({
            label: empresa.nome,
            value: empresa.id,
          }));
          setEmpresasOptions(options);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
    } finally {
      setCarregandoEmpresas(false);
    }
  };

  // Buscar formas de pagamento por empresa
  const buscarFormasPagamentoEmpresa = async (empresaId) => {
    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas/${empresaId}/formas-pagamento`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (response.ok) {
        const result = await response.json();
        // O backend retorna os dados em result.data
        const formasExistente = result.data || [];

        // Mapear as formas existentes para o formato do MultiSelect
        const formasMapeadas = formasExistente
          .filter((forma) => forma.descricao !== "Crédito Paciente")
          .map((forma) => ({
            id: forma.id,
            descricao: forma.descricao,
          }));

        // CORREÇÃO: Salvar no estado formasPagamento (que é usado no dropdown)
        setFormasPagamento(formasMapeadas);

        // Resetar forma de pagamento selecionada quando muda a empresa
        setFormaPagamento(null);

        // console.log("Formas carregadas:", formasMapeadas);
      } else {
        // Se não houver formas de pagamento, limpar
        setFormasPagamento([]);
        setFormaPagamento(null);
      }
    } catch (error) {
      console.error("Erro ao buscar formas de pagamento:", error);
      setFormasPagamento([]);
      setFormaPagamento(null);
    }
  };

  const fetchPacientes = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/pacientes",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar pacientes");
      }

      const data = await response.json();

      // console.log("Pacientes = ", data.data);

      if (data.success && Array.isArray(data.data)) {
        setPacientes(data.data);
        setError(null);
      } else {
        setPacientes([]);
        setError("Nenhuma empresa encontrada.");
      }
    } catch (error) {
      setError(error.message);
      setPacientes([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchPacientesCaixas = async (pacienteId) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/paciente-agendamentos/${pacienteId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar pacientes");
      }

      const data = await response.json();

      if (data.success && Array.isArray(data.data)) {
        setPacienteCaixa(data.data);
      } else {
        setPacienteCaixa([]);
        setError("Nenhum caixa encontrado.");
      }
    } catch (error) {
      setError(error.message);
      setPacienteCaixa([]);
    } finally {
      setLoading(false);
    }
  };

  const resetarCampos = () => {
    setNome("");
    setCpf("");
    setRg("");
    setDtNascimento("");
    setEmail("");
    setTelefone("");
    setLogradouro("");
    setNumero("");
    setBairro("");
    setCidade("");
    setEstado("");
    setCep("");
    setAtivo(true);
    setData("");
    setHora("");
    setProfissional("");
    setServico("");
    setEmpresa("");
  };

  // Validar formulário de adicionar
  const validarFormulario = () => {
    return nome.trim() && cpf.trim();
  };

  {
    /* --------------------------------------- FICHA --------------------------------------- */
  }
  const buscarFichaPaciente = async (pacienteId) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/agendas/${pacienteId}/paciente`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP ${response.status} - ${response.statusText}`);

      const data = await response.json();

      console.log("Ficha Paciente = ", data.data);

      if (data.success && data.data) {
        setPacienteEscolhido(data.data);

        // Processar o histórico de dentes - AGORA APENAS PARA VISUALIZAÇÃO
        const historicoMap = {};
        data.data.forEach((item) => {
          if (item.dentes && item.situacao) {
            const numeroDente = item.dentes.split("-")[0];
            if (
              !historicoMap[numeroDente] ||
              historicoMap[numeroDente] !== "2"
            ) {
              historicoMap[numeroDente] = item.situacao;
            }
          }
        });

        setHistoricoDentesMap(historicoMap);
      } else {
        throw new Error(data.message || "Erro na estrutura dos dados");
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados:", error);
      setError(error.message);
      setPacienteEscolhido([]);
      setHistoricoDentesMap({});
    } finally {
      setLoading(false);
    }
  };

  const handleNovoPaciente = async (paciente) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!nome || !cpf) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const pacienteData = {
        nome: nome,
        cpf: cpf,
        rg: rg,
        data_nascimento: dtNascimento,
        telefone: telefone,
        email: email,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        cep: cep,
        ativo: ativo ? "1" : "0",
      };

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/pacientes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(pacienteData),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Paciente cadastrado com sucesso!");
      setShowSuccessDialog(true);
      fetchPacientes();
      setVisibleNovoPaciente(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na adição:", err);
      setDialogMessage(
        err.message.includes("não cadastrado")
          ? "Paciente não cadastrado"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async (paciente) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!nome || !cpf) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const pacienteData = {
        nome: nome,
        cpf: cpf,
        rg: rg,
        data_nascimento: dtNascimento,
        telefone: telefone,
        email: email,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        cep: cep,
        ativo: ativo ? "1" : "0",
      };

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/pacientes/${paciente.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(pacienteData),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Paciente atualizado com sucesso!");
      setShowSuccessDialog(true);
      fetchPacientes();
      setVisibleEditar(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na edição:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Paciente não encontrado ou já removido"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  // Função para alternar um item específico
  const alternarDetalhes = (id) => {
    setItensExpandidos((prev) =>
      prev.includes(id)
        ? prev.filter((itemId) => itemId !== id)
        : [...prev, id],
    );
  };

  const handleAdicionarSaldo = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      // Validar campos obrigatórios
      if (!valorAdicionar || parseFloat(valorAdicionar) <= 0) {
        setDialogMessage("Informe um valor válido para adicionar");
        setShowErrorDialog(true);
        return;
      }

      if (!empresa) {
        setDialogMessage("Selecione uma empresa");
        setShowErrorDialog(true);
        return;
      }

      if (!formaPagamento) {
        setDialogMessage("Selecione a forma de pagamento");
        setShowErrorDialog(true);
        return;
      }

      const saldoData = {
        paciente_id: pacienteEditando.id,
        valor: parseFloat(valorAdicionar),
        empresa_id: empresa,
        forma_pagamento: formaPagamento,
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/pacientes/saldo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(saldoData),
        },
      );

      const responseData = await response.json();

      //  console.log("responseData = ", responseData.data);

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      //Atualizar Saldo
      setSaldo((responseData.data?.saldo_atual).toFixed(2));

      setDialogMessage(
        `Saldo de R$ ${parseFloat(valorAdicionar).toFixed(2)} adicionado com sucesso!`,
      );
      setShowSuccessDialog(true);

      // Resetar campos e fechar dialog
      setValorAdicionar("");
      setEmpresa(null);
      setFormaPagamento(null);
      setVisibleAdicionarSaldo(false);

      // Atualizar a lista de pacientes para refletir o novo saldo
      fetchPacientes();
    } catch (err) {
      console.error("Erro ao adicionar saldo:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Paciente não encontrado"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  // ==========================================================================
  // COMPONENTES DE DENTES MEMOIZADOS - AGORA APENAS PARA VISUALIZAÇÃO
  // ==========================================================================

  const DentesAdultoMemo = React.memo(
    ({ historicoDentes }) => {
      const getDenteSituacao = (denteNumber) => {
        // APENAS PARA VISUALIZAÇÃO - SEM LÓGICA DE SELEÇÃO
        if (denteNumber.includes("-Central")) {
          const numeroDente = denteNumber.split("-")[0];
          if (historicoDentes && historicoDentes[numeroDente]) {
            return parseInt(historicoDentes[numeroDente]) || 0;
          }
        }

        return 0;
      };

      const getCorPorSituacao = (situacao) => {
        switch (situacao) {
          case 1:
            return {
              backgroundColor: "#e3f2fd",
              color: "#1976d2",
              borderColor: "#1976d2",
            };
          case 2:
            return {
              backgroundColor: "#ffebee",
              color: "#c62828",
              borderColor: "#c62828",
            };
          default:
            return {
              backgroundColor: "",
              color: "",
              borderColor: "",
            };
        }
      };

      const DenteIndividual = ({ numero, numeroExibido }) => {
        const partes = [
          { number: `${numeroExibido}-Superior`, position: "top" },
          { number: `${numeroExibido}-Direita`, position: "right" },
          { number: `${numeroExibido}-Inferior`, position: "bottom" },
          { number: `${numeroExibido}-Esquerda`, position: "left" },
        ];
        const central = `${numeroExibido}-Central`;

        const situacaoCentral = getDenteSituacao(central);
        const coresCentral = getCorPorSituacao(situacaoCentral);

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "0 -5px",
            }}
          >
            <div
              style={{
                marginBottom: "4px",
                fontSize: "14px",
                fontWeight: "bold",
                height: "5px",
              }}
            >
              {numeroExibido}
            </div>

            <div className="dente-container">
              {partes.map((parte) => {
                const situacao = getDenteSituacao(parte.number);
                const cores = getCorPorSituacao(situacao);
                const temCor = cores.backgroundColor !== "";

                // DESABILITADO E SEM FUNÇÃO DE CLICK
                return (
                  <button
                    key={parte.number}
                    className={`botao-dente ${parte.position} ${
                      !temCor &&
                      (situacao === 1
                        ? "pendente"
                        : situacao === 2
                          ? "finalizado"
                          : "")
                    }`}
                    style={temCor ? cores : {}}
                    disabled={true}
                    title={
                      situacao === 1
                        ? "Pendente (Histórico)"
                        : situacao === 2
                          ? "Concluído (Histórico)"
                          : "Sem histórico"
                    }
                  >
                    {parte.number.split("-")[1].charAt(0).toUpperCase()}
                  </button>
                );
              })}
              <button
                className={`botao-central ${
                  [1, 2].includes(situacaoCentral)
                    ? situacaoCentral === 1
                      ? "pendente"
                      : "finalizado"
                    : ""
                }`}
                style={[1, 2].includes(situacaoCentral) ? coresCentral : {}}
                disabled={true}
                title={
                  situacaoCentral === 1
                    ? "Pendente (Histórico)"
                    : situacaoCentral === 2
                      ? "Concluído (Histórico)"
                      : "Sem histórico"
                }
              >
                {numeroExibido}
              </button>
            </div>
          </div>
        );
      };

      const numerosExibicaoSuperior = [
        18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
      ];
      const numerosExibicaoInferior = [
        48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
      ];

      return (
        <div style={{ width: "100%", padding: "0 2px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "nowrap",
              marginBottom: "15px",
            }}
          >
            {numerosExibicaoSuperior.map((numExibido, index) => (
              <React.Fragment key={`sup-${index}`}>
                <DenteIndividual
                  numero={index + 1}
                  numeroExibido={numExibido}
                />
                {index === 7 && <div style={{ width: "20px" }} />}
              </React.Fragment>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "nowrap",
            }}
          >
            {numerosExibicaoInferior.map((numExibido, index) => (
              <React.Fragment key={`inf-${index}`}>
                <DenteIndividual
                  numero={index + 17}
                  numeroExibido={numExibido}
                />
                {index === 7 && <div style={{ width: "20px" }} />}
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    },
    (prevProps, nextProps) => {
      // Comparação simplificada para o histórico
      return (
        JSON.stringify(prevProps.historicoDentes) ===
        JSON.stringify(nextProps.historicoDentes)
      );
    },
  );

  const DentesInfantilMemo = React.memo(
    ({ historicoDentes }) => {
      const getDenteSituacao = (denteNumber) => {
        // APENAS PARA VISUALIZAÇÃO - SEM LÓGICA DE SELEÇÃO
        if (denteNumber.includes("-Central")) {
          const numeroDente = denteNumber.split("-")[0];
          if (historicoDentes && historicoDentes[numeroDente]) {
            return parseInt(historicoDentes[numeroDente]) || 0;
          }
        }

        return 0;
      };

      const getCorPorSituacao = (situacao) => {
        switch (situacao) {
          case 1:
            return {
              backgroundColor: "#e3f2fd",
              color: "#1976d2",
              borderColor: "#1976d2",
            };
          case 2:
            return {
              backgroundColor: "#ffebee",
              color: "#c62828",
              borderColor: "#c62828",
            };
          default:
            return {
              backgroundColor: "",
              color: "",
              borderColor: "",
            };
        }
      };

      const DenteIndividual = ({ numero, numeroExibido }) => {
        const partes = [
          { number: `${numeroExibido}-Superior`, position: "top" },
          { number: `${numeroExibido}-Direita`, position: "right" },
          { number: `${numeroExibido}-Inferior`, position: "bottom" },
          { number: `${numeroExibido}-Esquerda`, position: "left" },
        ];
        const central = `${numeroExibido}-Central`;

        const situacaoCentral = getDenteSituacao(central);
        const coresCentral = getCorPorSituacao(situacaoCentral);

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "0 5px",
            }}
          >
            <div
              style={{
                marginBottom: "4px",
                fontSize: "14px",
                fontWeight: "bold",
                height: "5px",
              }}
            >
              {numeroExibido}
            </div>

            <div className="dente-container">
              {partes.map((parte) => {
                const situacao = getDenteSituacao(parte.number);
                const cores = getCorPorSituacao(situacao);
                const temCor = cores.backgroundColor !== "";

                // DESABILITADO E SEM FUNÇÃO DE CLICK
                return (
                  <button
                    key={parte.number}
                    className={`botao-dente ${parte.position} ${
                      !temCor &&
                      (situacao === 1
                        ? "pendente"
                        : situacao === 2
                          ? "finalizado"
                          : "")
                    }`}
                    style={temCor ? cores : {}}
                    disabled={true}
                    title={
                      situacao === 1
                        ? "Pendente (Histórico)"
                        : situacao === 2
                          ? "Concluído (Histórico)"
                          : "Sem histórico"
                    }
                  >
                    {parte.number.split("-")[1].charAt(0).toUpperCase()}
                  </button>
                );
              })}
              <button
                className={`botao-central ${
                  [1, 2].includes(situacaoCentral)
                    ? situacaoCentral === 1
                      ? "pendente"
                      : "finalizado"
                    : ""
                }`}
                style={[1, 2].includes(situacaoCentral) ? coresCentral : {}}
                disabled={true}
                title={
                  situacaoCentral === 1
                    ? "Pendente (Histórico)"
                    : situacaoCentral === 2
                      ? "Concluído (Histórico)"
                      : "Sem histórico"
                }
              >
                {numeroExibido}
              </button>
            </div>
          </div>
        );
      };

      const numerosExibicaoSuperior = [55, 54, 53, 52, 51, 61, 62, 63, 64, 65];
      const numerosExibicaoInferior = [85, 84, 83, 82, 81, 71, 72, 73, 74, 75];

      const renderizarGrupos = (dentes, inicioIndex) => {
        const grupos = [];
        for (let i = 0; i < dentes.length; i += 5) {
          const grupo = dentes.slice(i, i + 5);
          grupos.push(
            <div
              key={`grupo-${i}`}
              style={{ display: "flex", margin: "0 10px" }}
            >
              {grupo.map((numExibido, index) => (
                <DenteIndividual
                  key={`${inicioIndex}-${i + index}`}
                  numero={inicioIndex + i + index + 1}
                  numeroExibido={numExibido}
                />
              ))}
            </div>,
          );
        }
        return grupos;
      };

      return (
        <div style={{ width: "100%", padding: "0 2px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "nowrap",
              marginBottom: "15px",
            }}
          >
            {renderizarGrupos(numerosExibicaoSuperior, 0)}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "nowrap",
            }}
          >
            {renderizarGrupos(numerosExibicaoInferior, 10)}
          </div>
        </div>
      );
    },
    (prevProps, nextProps) => {
      // Comparação simplificada para o histórico
      return (
        JSON.stringify(prevProps.historicoDentes) ===
        JSON.stringify(nextProps.historicoDentes)
      );
    },
  );

  {
    /* --------------------------------------- FINANCEIRO --------------------------------------- */
  }
  const calcularCarteira = () => {
    return pacienteCaixa
      .filter(
        (p) => p.caixa_status === "fechado" && Array.isArray(p.pagamentos),
      )
      .reduce((total, p) => {
        const totalCarteira = p.pagamentos
          .filter(
            (pag) =>
              pag.forma_pagamento_descricao === "Carteira" && pag.valor != null,
          )
          .reduce((soma, pag) => soma + parseFloat(pag.valor || 0), 0);

        return total + totalCarteira;
      }, 0);
  };

  const calcularVlrPendentes = () => {
    // Somar o valor total quando caixa_status: "aberto" e tem valor_total
    // Não somar quando caixa_status: null e valor_total=null
    return pacienteCaixa
      .filter(
        (p) =>
          p.caixa_status === "aberto" &&
          p.valor_total !== null &&
          p.valor_total !== undefined,
      )
      .reduce((total, p) => total + parseFloat(p.valor_total || 0), 0);
  };

  const calcularReceitaBruta = () => {
    const total = pacienteCaixa
      .filter((item) => item.caixa_status === "fechado")
      .reduce((acc, item) => {
        return acc + parseFloat(item.valor_original || 0);
      }, 0);

    return total.toFixed(2);
  };

  const calcularTotalDescontos = () => {
    const total = pacienteCaixa
      .filter((item) => item.caixa_status === "fechado")
      .reduce((acc, item) => {
        return acc + parseFloat(item.valor_desconto || 0);
      }, 0);
    return total.toFixed(2);
  };

  const calcularTotalAcrescimos = () => {
    const total = pacienteCaixa
      .filter((item) => item.caixa_status === "fechado")
      .reduce((acc, item) => {
        return acc + parseFloat(item.valor_acrescimo || 0);
      }, 0);
    return total.toFixed(2);
  };

  const calcularReceitaLiquida = () => {
    const total = pacienteCaixa
      .filter((item) => item.caixa_status === "fechado")
      .reduce((acc, item) => {
        return acc + parseFloat(item.valor_total || 0);
      }, 0);

    return total.toFixed(2);
  };

  {
    /* --------------------------------------- CAIXA --------------------------------------- */
  }
  // Função para processar o pagamento
  const handleConfirmarPagamento = async (pagamentoSelecionado) => {
    setLoading(true);

    try {
      // Validações
      if (!tipoPagamento) {
        throw new Error("Selecione uma forma de pagamento");
      }

      // Encontrar o pagamento em carteira no array de pagamentos
      const pagamentoCarteira = pagamentoSelecionado.pagamentos.find(
        (pag) =>
          pag.forma_pagamento_descricao === "Carteira" ||
          pag.forma_pagamento_id === "4",
      );

      if (!pagamentoCarteira) {
        throw new Error(
          "Não foi encontrado pagamento em carteira para este atendimento",
        );
      }

      // Preparar dados para envio
      const dadosEnvio = {
        caixa_id: pagamentoSelecionado.caixa_id,
        pagamento_id: pagamentoCarteira.id,
        forma_pagamento_id: Number(tipoPagamento.id),
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/caixas/editar-pagamento",
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(dadosEnvio),
        },
      );

      const data = await response.json();

      if (data.success) {
        // Fecha o diálogo e limpa os estados
        setVisibleCaixa(false);
        setAcrescimo("");
        setDesconto("");
        setTipoPagamento(null);

        showSuccessMessage("Caixa finalizado com sucesso!");
      } else {
        throw new Error(data.message || "Erro ao processar pagamento");
      }
    } catch (error) {
      console.error("Erro:", error);
      showErrorMessage(error.message || "Erro ao processar pagamento");
    } finally {
      setLoading(false);
    }
  };

  // Função para calcular o valor final
  const calcularValorFinal = () => {
    const valorBase = parseFloat(pagamentoSelecionado.pagamento_valor) || 0;
    const valorAcrescimo = parseFloat(acrescimo) || 0;
    const valorDesconto = parseFloat(desconto) || 0;

    return valorBase + valorAcrescimo - valorDesconto;
  };

  // Quantidade de pagamentos de carteira já realizados
  const calcularValorPago = () => {
    if (!Array.isArray(pacienteCaixa)) return 0;

    return pacienteCaixa.reduce((total, item) => {
      if (item.caixa_status !== "fechado") return total; // só caixas fechadas

      const pagamentos = Array.isArray(item?.pagamentos) ? item.pagamentos : [];

      // Soma todos os pagamentos que NÃO são Carteira
      const valorPagoNoCaixa = pagamentos.reduce((soma, p) => {
        if (p.forma_pagamento_descricao?.toLowerCase() !== "carteira") {
          return soma + Number(p.valor || 0);
        }
        return soma;
      }, 0);

      return total + valorPagoNoCaixa;
    }, 0);
  };

  // Quantidade de pagamentos de carteira ainda pendentes
  const calcularPendenteCarteira = () => {
    if (!Array.isArray(pacienteCaixa)) return 0;

    return pacienteCaixa.reduce((total, item) => {
      if (item.caixa_status !== "fechado") return total; // só caixas fechadas

      const pagamentos = Array.isArray(item?.pagamentos) ? item.pagamentos : [];

      // Soma todos os pagamentos que NÃO são Carteira
      const valorPagoNoCaixa = pagamentos.reduce((soma, p) => {
        if (p.forma_pagamento_descricao?.toLowerCase() === "carteira") {
          return soma + Number(p.valor || 0);
        }
        return soma;
      }, 0);

      return total + valorPagoNoCaixa;
    }, 0);
  };

  const contarPagamentosCarteira = () => {
    if (!Array.isArray(pacienteCaixa)) return 0;

    return pacienteCaixa.reduce((total, item) => {
      const pagamentos = Array.isArray(item?.pagamentos) ? item.pagamentos : [];

      // Conta apenas os pagamentos que são Carteira
      const carteiraCount = pagamentos.filter(
        (p) => p.forma_pagamento_descricao?.toLowerCase() === "carteira",
      ).length;

      return total + carteiraCount;
    }, 0);
  };

  // Função para mostrar mensagem de sucesso
  const showSuccessMessage = (message) => {
    setDialogMessage(message);
    setShowSuccessDialog(true);
  };

  // Função para mostrar mensagem de erro
  const showErrorMessage = (message) => {
    setDialogMessage(message);
    setShowErrorDialog(true);
  };

  // Função para tabela de pamentos
  const historicoPagamentos =
    pacienteCaixa
      ?.filter((item) => item.caixa_status === "fechado")
      .flatMap((item) =>
        (item.pagamentos || []).map((pagamento) => ({
          ...item, // mantém dados do caixa
          pagamento_valor: pagamento.valor,
          pagamento_data: pagamento.data_pagamento,
          pagamento_forma: pagamento.forma_pagamento_descricao,
        })),
      ) || [];

  const pagamentosCarteira = pacienteCaixa
    .filter((item) => item.caixa_status === "fechado") // apenas caixas fechadas
    .flatMap((item) =>
      (item.pagamentos || [])
        .filter(
          (pagamento) => pagamento.forma_pagamento_descricao === "Carteira",
        ) // só "Carteira"
        .map((pagamento) => ({
          ...item, // mantém dados do caixa
          pagamento_valor: pagamento.valor,
          pagamento_data: pagamento.data_pagamento,
          pagamento_forma: pagamento.forma_pagamento_descricao,
        })),
    );

  {
    /* --------------------------------------- ADICIONAR AGENDA --------------------------------------- */
  }

  const fetchTodosDados = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/agendamento/dados",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP ${response.status} - ${response.statusText}`);

      const result = await response.json();

      if (result.success && result.data) {
        setDadosCompletos({
          empresas: result.data.empresas || [],
          profissionais: result.data.profissionais || [],
          servicos: result.data.servicos || [],
          datas_atendimento: result.data.datas_atendimento || [],
          horarios: result.data.horarios || [],
          agendamentos_existentes: result.data.agendamentos_existentes || [],
        });

        // Inicializar profissionais filtrados com todos os profissionais
        setProfissionaisFiltrados(
          result.data.profissionais.map((prof) => ({
            label: prof.nome,
            value: prof.id,
          })),
        );

        // Inicializar serviços filtrados com todos os serviços
        setServicosFiltrados(
          result.data.servicos.map((serv) => ({
            label: `${serv.nome} - ${serv.duracao}min - R$ ${parseFloat(serv.valor).toFixed(2)}`,
            value: serv.id,
            nome: serv.nome,
            duracao: serv.duracao,
            valor: parseFloat(serv.valor).toFixed(2),
            descricao: serv.nome,
          })),
        );
      } else {
        throw new Error(result.message || "Erro na estrutura dos dados");
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados:", error);
      setError(error.message);
      setDadosCompletos({
        empresas: [],
        profissionais: [],
        servicos: [],
        datas_atendimento: [],
        horarios: [],
        agendamentos_existentes: [],
      });
    } finally {
      setLoading(false);
    }
  };

  // Função para salvar novo agendamento
  const handleAdicionarAgenda = async () => {
    setLoading(true);

    try {
      // Formatar data e hora
      const dataHora = `${data} ${hora}:00`;

      // Montar payload conforme endpoint
      const payload = {
        empresa_id: empresa,
        profissional_id: profissional,
        servico_id: servico,
        data_hora: dataHora,
        paciente: {
          nome: pacienteEditando.nome,
          cpf: pacienteEditando.cpf,
          telefone: pacienteEditando.telefone || "",
          email: pacienteEditando.email || "",
        },
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/agendaPaciente",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (result.success) {
        showSuccessMessage("Agendamento realizado com sucesso!");

        // Resetar e fechar modal
        resetarCampos();
        setVisibleAdicionar(false);
        setPacienteEditando([]);

        // Atualizar lista de Pacientes
        fetchPacientes();

        setDadosCompletos({
          empresas: [],
          profissionais: [],
          servicos: [],
          datas_atendimento: [],
          horarios: [],
          agendamentos_existentes: [],
        });
      } else {
        showErrorMessage(result.message || "Erro ao realizar agendamento");
      }
    } catch (error) {
      console.error("Erro:", error);
      showErrorMessage("Erro de conexão com o servidor");
    } finally {
      setLoading(false);
    }
  };

  {
    /* --------------------------------------- Filtros --------------------------------------- */
  }
  // 1. Filtrar profissionais por empresa
  const filtrarProfissionaisPorEmpresa = (empresaId) => {
    if (!empresaId) {
      const todosProfissionais = dadosCompletos.profissionais.map((prof) => ({
        label: prof.nome,
        value: prof.id,
      }));
      setProfissionaisFiltrados(todosProfissionais);

      // Resetar serviços para mostrar todos
      setServicosFiltrados(
        dadosCompletos.servicos.map((serv) => ({
          label: serv.nome,
          value: serv.id,
        })),
      );
      return;
    }

    const profissionaisNaEmpresa = dadosCompletos.profissionais.filter((prof) =>
      prof.empresas?.some(
        (empresa) => empresa.id.toString() === empresaId.toString(),
      ),
    );

    const optionsFiltradas = profissionaisNaEmpresa.map((prof) => ({
      label: prof.nome,
      value: prof.id,
    }));

    setProfissionaisFiltrados(optionsFiltradas);

    // Resetar serviços para mostrar todos (até que um profissional seja selecionado)
    setServicosFiltrados(
      dadosCompletos.servicos.map((serv) => ({
        label: serv.nome,
        value: serv.id,
      })),
    );

    // Limpar seleções dependentes
    setProfissional("");
    setData("");
    setHora("");
    setDatasDisponiveis([]);
    setHorariosDisponiveis([]);
  };

  // 2. Filtrar datas por profissional
  const filtrarDatasPorProfissional = (profissionalId) => {
    if (!profissionalId) {
      setDatasDisponiveis([]);
      setData("");
      setHora("");
      setServicosFiltrados(
        dadosCompletos.servicos.map((serv) => ({
          label: serv.nome,
          value: serv.id,
        })),
      );
      return;
    }

    const datasDoProfissional = dadosCompletos.datas_atendimento.filter(
      (data) => data.profissional_id.toString() === profissionalId.toString(),
    );

    const datasFormatadas = datasDoProfissional.map((data) => ({
      label: new Date(data.data_atendimento + "T00:00:00").toLocaleDateString(
        "pt-BR",
      ),
      value: data.data_atendimento,
    }));

    setDatasDisponiveis(datasFormatadas);

    // Filtrar serviços para este profissional
    filtrarServicosPorProfissional(profissionalId);

    // Limpar seleções dependentes
    setData("");
    setHora("");
    setHorariosDisponiveis([]);
  };

  // 3. Filtrar horários por profissional e data
  const filtrarHorariosPorProfissionalEData = (profissionalId, data) => {
    if (!profissionalId || !data) {
      setHorariosDisponiveis([]);
      setHora("");
      return;
    }

    const dataObj = new Date(data + "T00:00:00");
    const diaSemana = dataObj.getDay();

    // Horários cadastrados para o profissional neste dia da semana
    const horariosCadastrados = dadosCompletos.horarios.filter(
      (horario) =>
        horario.profissional_id.toString() === profissionalId.toString() &&
        parseInt(horario.dia_semana) === diaSemana,
    );

    // Horários já agendados
    const horariosOcupados = dadosCompletos.agendamentos_existentes
      .filter(
        (agendamento) =>
          agendamento.profissional_id.toString() ===
            profissionalId.toString() &&
          agendamento.data_atendimento === data &&
          agendamento.status_reserva !== "cancelada",
      )
      .map((agendamento) => agendamento.horario);

    // Horários disponíveis
    const horariosDisponiveisFiltrados = horariosCadastrados
      .map((horario) => horario.hora)
      .filter((horario) => !horariosOcupados.includes(horario))
      .filter((horario) => {
        // Não permitir horários no passado
        const agora = new Date();
        const dataHoraAgendamento = new Date(data + "T" + horario + ":00");
        return dataHoraAgendamento > agora;
      })
      .sort()
      .map((horario) => ({
        label: horario,
        value: horario,
      }));

    setHorariosDisponiveis(horariosDisponiveisFiltrados);
    setHora("");
  };

  // 4. Filtrar serviços por profissional
  const filtrarServicosPorProfissional = (profissionalId) => {
    if (!profissionalId) {
      // Se não há profissional selecionado, mostrar todos os serviços
      const todosServicos = dadosCompletos.servicos.map((serv) => ({
        label: serv.nome,
        value: serv.id,
      }));
      setServicosFiltrados(todosServicos);
      return;
    }

    // Encontrar o profissional selecionado
    const profissionalSelecionado = dadosCompletos.profissionais.find(
      (prof) => prof.id.toString() === profissionalId.toString(),
    );

    if (!profissionalSelecionado) {
      setServicosFiltrados([]);
      return;
    }

    // Se o profissional tem serviços específicos, usar apenas esses
    if (
      profissionalSelecionado.servicos &&
      profissionalSelecionado.servicos.length > 0
    ) {
      const servicosDoProfissional = profissionalSelecionado.servicos.map(
        (serv) => ({
          label: serv.nome,
          value: serv.id,
        }),
      );
      setServicosFiltrados(servicosDoProfissional);
    } else {
      // Se o profissional não tem serviços específicos, mostrar todos os serviços
      const todosServicos = dadosCompletos.servicos.map((serv) => ({
        label: serv.nome,
        value: serv.id,
      }));
      setServicosFiltrados(todosServicos);
    }
  };

  {
    /* --------------------------------------- FICHA DO PACIENTE --------------------------------------- */
  }

  // Estado para a ficha
  const [fichaData, setFichaData] = useState({
    // ANAMNESE
    tem_problema_saude: false,
    qual_problema_saude: "",
    em_tratamento_medico: false,
    motivo_tratamento_medico: "",
    usa_medicamento: false,
    quais_medicamentos: "",
    alergia_medicamento: false,
    quais_alergias: "",
    pressao_arterial: "",
    fumante: false,

    // SAÚDE BUCAL
    gengiva_sangra: false,
    sensibilidade_dentes: false,
    escovacoes_por_dia: null,
    usa_fio_dental: false,
    frequencia_fio_dental: "",
    roi_unhas: false,
    morde_lapis: false,
    outros_habitos: "",

    // EXAME GERAL
    higiene_bucal: "Regular",
    halitose: "Ausente",
    mucosa: "Normal",
    lingua: "",
    palato: "",
    palato_mole: "",
    assoalho_bucal: "",
    labios: "",

    // PERIODONTAL
    placa_bacteriana: false,
    sangramento_gengival: false,
    tartaro: false,
    mobilidade_dental: false,

    // ORTODÔNTICO
    apinhamento: "Ausente",
    diastemas: false,

    // OBSERVAÇÕES
    observacoes: "",
    plano_tratamento: "",
    data_assinatura: null,
    mes_assinatura: "",
    ano_assinatura: "",
  });

  // Função para resetar campos
  const resetarCamposFicha = () => {
    setFichaData({
      tem_problema_saude: false,
      qual_problema_saude: "",
      em_tratamento_medico: false,
      motivo_tratamento_medico: "",
      usa_medicamento: false,
      quais_medicamentos: "",
      alergia_medicamento: false,
      quais_alergias: "",
      pressao_arterial: "",
      fumante: false,
      gengiva_sangra: false,
      sensibilidade_dentes: false,
      escovacoes_por_dia: null,
      usa_fio_dental: false,
      frequencia_fio_dental: "",
      roi_unhas: false,
      morde_lapis: false,
      outros_habitos: "",
      higiene_bucal: "Regular",
      halitose: "Ausente",
      mucosa: "Normal",
      lingua: "",
      palato: "",
      palato_mole: "",
      assoalho_bucal: "",
      labios: "",
      placa_bacteriana: false,
      sangramento_gengival: false,
      tartaro: false,
      mobilidade_dental: false,
      apinhamento: "Ausente",
      diastemas: false,
      observacoes: "",
      plano_tratamento: "",
      data_assinatura: null,
      mes_assinatura: "",
      ano_assinatura: "",
    });
  };

  // Função para salvar a ficha
  const handleSalvarFicha = async () => {
    try {
      setLoading(true);

      const payload = {
        paciente_id: pacienteEditando.id,
        ...fichaData,
        // Formatar data se necessário
        data_assinatura: fichaData.data_assinatura
          ? format(fichaData.data_assinatura, "yyyy-MM-dd")
          : null,
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/fichas",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (result.success) {
        showSuccessMessage("Ficha salva com sucesso!");

        // Resetar e fechar modal
        resetarCamposFicha();
        setVisibleFicha(false);
      } else {
        showErrorMessage(result.message || "Erro ao salvar Ficha");
      }
    } catch (error) {
      console.error("Erro:", error);
      showErrorMessage("Erro de conexão com o servidor");
    } finally {
      setLoading(false);
    }
  };

  const fetchDadosFicha = async (pacienteId) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/fichas/paciente/${pacienteId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP ${response.status} - ${response.statusText}`);

      const result = await response.json();

      if (result.data) {
        // Converte os dados do banco para o formato do estado
        const dadosConvertidos = {
          // ANAMNESE - Problemas de Saúde
          tem_problema_saude:
            result.data.tem_problema_saude === "1" ||
            result.data.tem_problema_saude === 1 ||
            result.data.tem_problema_saude === true,
          qual_problema_saude: result.data.qual_problema_saude || "",

          em_tratamento_medico:
            result.data.em_tratamento_medico === "1" ||
            result.data.em_tratamento_medico === 1 ||
            result.data.em_tratamento_medico === true,
          motivo_tratamento_medico: result.data.motivo_tratamento_medico || "",

          usa_medicamento:
            result.data.usa_medicamento === "1" ||
            result.data.usa_medicamento === 1 ||
            result.data.usa_medicamento === true,
          quais_medicamentos: result.data.quais_medicamentos || "",

          alergia_medicamento:
            result.data.alergia_medicamento === "1" ||
            result.data.alergia_medicamento === 1 ||
            result.data.alergia_medicamento === true,
          quais_alergias: result.data.quais_alergias || "",

          pressao_arterial: result.data.pressao_arterial || "",

          fumante:
            result.data.fumante === "1" ||
            result.data.fumante === 1 ||
            result.data.fumante === true,

          // SAÚDE BUCAL
          gengiva_sangra:
            result.data.gengiva_sangra === "1" ||
            result.data.gengiva_sangra === 1 ||
            result.data.gengiva_sangra === true,
          sensibilidade_dentes:
            result.data.sensibilidade_dentes === "1" ||
            result.data.sensibilidade_dentes === 1 ||
            result.data.sensibilidade_dentes === true,

          escovacoes_por_dia: result.data.escovacoes_por_dia
            ? parseInt(result.data.escovacoes_por_dia)
            : null,

          usa_fio_dental:
            result.data.usa_fio_dental === "1" ||
            result.data.usa_fio_dental === 1 ||
            result.data.usa_fio_dental === true,
          frequencia_fio_dental: result.data.frequencia_fio_dental || "",

          roi_unhas:
            result.data.roi_unhas === "1" ||
            result.data.roi_unhas === 1 ||
            result.data.roi_unhas === true,
          morde_lapis:
            result.data.morde_lapis === "1" ||
            result.data.morde_lapis === 1 ||
            result.data.morde_lapis === true,
          outros_habitos: result.data.outros_habitos || "",

          // EXAME GERAL
          higiene_bucal: result.data.higiene_bucal || "Regular",
          halitose: result.data.halitose || "Ausente",
          mucosa: result.data.mucosa || "Normal",
          lingua: result.data.lingua || "",
          palato: result.data.palato || "",
          palato_mole: result.data.palato_mole || "",
          assoalho_bucal: result.data.assoalho_bucal || "",
          labios: result.data.labios || "",

          // PERIODONTAL
          placa_bacteriana:
            result.data.placa_bacteriana === "1" ||
            result.data.placa_bacteriana === 1 ||
            result.data.placa_bacteriana === true,
          sangramento_gengival:
            result.data.sangramento_gengival === "1" ||
            result.data.sangramento_gengival === 1 ||
            result.data.sangramento_gengival === true,
          tartaro:
            result.data.tartaro === "1" ||
            result.data.tartaro === 1 ||
            result.data.tartaro === true,
          mobilidade_dental:
            result.data.mobilidade_dental === "1" ||
            result.data.mobilidade_dental === 1 ||
            result.data.mobilidade_dental === true,

          // ORTODÔNTICO
          apinhamento: result.data.apinhamento || "Ausente",
          diastemas:
            result.data.diastemas === "1" ||
            result.data.diastemas === 1 ||
            result.data.diastemas === true,

          // OBSERVAÇÕES
          observacoes: result.data.observacoes || "",
          plano_tratamento: result.data.plano_tratamento || "",

          // ASSINATURA
          data_assinatura: result.data.data_assinatura
            ? new Date(result.data.data_assinatura)
            : null,
          mes_assinatura: result.data.mes_assinatura?.toString() || "",
          ano_assinatura: result.data.ano_assinatura?.toString() || "",
        };

        setFichaData(dadosConvertidos);
      } else {
        // Reseta para uma ficha nova
        setFichaData({
          tem_problema_saude: false,
          qual_problema_saude: "",
          em_tratamento_medico: false,
          motivo_tratamento_medico: "",
          usa_medicamento: false,
          quais_medicamentos: "",
          alergia_medicamento: false,
          quais_alergias: "",
          pressao_arterial: "",
          fumante: false,
          gengiva_sangra: false,
          sensibilidade_dentes: false,
          escovacoes_por_dia: null,
          usa_fio_dental: false,
          frequencia_fio_dental: "",
          roi_unhas: false,
          morde_lapis: false,
          outros_habitos: "",
          higiene_bucal: "Regular",
          halitose: "Ausente",
          mucosa: "Normal",
          lingua: "",
          palato: "",
          palato_mole: "",
          assoalho_bucal: "",
          labios: "",
          placa_bacteriana: false,
          sangramento_gengival: false,
          tartaro: false,
          mobilidade_dental: false,
          apinhamento: "Ausente",
          diastemas: false,
          observacoes: "",
          plano_tratamento: "",
          data_assinatura: null,
          mes_assinatura: "",
          ano_assinatura: "",
        });
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Função para imprimir a ficha
  const handleImprimirFicha = () => {
    if (!fichaData || !pacienteEditando) return;

    // Cria uma nova janela para impressão
    const printWindow = window.open("", "_blank");

    // Formata a data atual
    const dataAtual = new Date().toLocaleDateString("pt-BR");

    // Função auxiliar para formatar booleanos
    const formatarSimNao = (valor) => {
      return valor ? "Sim" : "Não";
    };

    // Template HTML compactado mas com layout um abaixo do outro
    const htmlContent = `
  <!DOCTYPE html>
  <html>
  <head>     
    <meta charset="utf-8">
    <title>Ficha do Paciente - ${pacienteEditando.nome || "Impressão"}</title>
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      
      body {
        font-family: 'Arial', sans-serif;
        background: white;
        padding: 8px;
        color: #333;
        font-size: 11px;
      }
      
      .container {
        max-width: 100%;
        margin: 0 auto;
      }
      
      .logo-container {
        text-align: center;
        margin-bottom: 15px;
      }
      
      .logo {
        width: 200px;
        height: auto;
      }
      
      .header {
        text-align: center;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        padding: 6px;
      }
      
      .header h1 {
        color: #2c3e50;
        font-size: 16px;
        margin-bottom: 2px;
      }
      
      .data-impressao {
        text-align: right;
        color: #95a5a6;
        font-size: 9px;
        margin-bottom: 6px;
      }
      
      /* Container para alinhar data e título na mesma linha */
      .cabecalho-impressao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 6px;
      }
      
      .titulo-impressao {
        color: #95a5a6;
        font-size: 9px;
        text-align: right;
      }
      
      .paciente-info {
        background: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        padding: 6px;
        margin-bottom: 8px;
      }
      
      .paciente-info h3 {
        color: #3498db;
        font-size: 12px;
        margin-bottom: 4px;
        padding-bottom: 2px;
        border-bottom: 1px solid #3498db;
      }
      
      .paciente-info-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 4px;
      }
      
      .paciente-info-item {
        font-size: 10px;
      }
      
      .paciente-info-item strong {
        color: #7f8c8d;
        font-weight: 600;
      }
      
      .section {
        border: 1px solid #dee2e6;
        border-radius: 4px;
        margin-bottom: 8px;
        overflow: hidden;
      }
      
      .section-title {
        padding: 4px 8px;
        font-weight: bold;
        font-size: 12px;
        color: white;
      }
      
      .section-content {
        padding: 8px;
        background: white;
      }
      
      .anamnese-title { background: #27ae60; }
      .saude-bucal-title { background: #e67e22; }
      .observacoes-title { background: #8e44ad; }
      
      /* Grid de 2 colunas para ANAMNESE e Saúde Bucal */
      .grid-2-colunas {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }
      
      .campo {
        margin-bottom: 6px;
      }
      
      .campo-label {
        font-weight: 600;
        color: #2c3e50;
        font-size: 10px;
        margin-bottom: 1px;
      }
      
      .campo-valor {
        color: #34495e;
        font-size: 11px;
        padding: 2px 0;
        border-bottom: 1px dotted #ecf0f1;
      }
      
      .campo-valor-booleano {
        display: inline-block;
        padding: 1px 5px;
        border-radius: 8px;
        font-size: 9px;
        font-weight: 600;
      }
      
      .sim {
        background: #d4edda;
        color: #155724;
      }
      
      .nao {
        background: #f8d7da;
        color: #721c24;
      }
      
      .assinatura {
        margin-top: 8px;
        padding-top: 6px;
        text-align: center;
      }
      
      .assinatura-linha {
        width: 250px;
        margin: 4px auto 2px;
        border-top: 1px solid #333;
      }
      
      .inline-campos {
        display: flex;
        gap: 15px;
        margin-bottom: 4px;
      }
      
      .inline-campo {
        flex: 1;
      }
      
      /* Ajuste para melhor visualização em grid */
      .coluna {
        break-inside: avoid;
      }
      
      @media print {
        body { 
          padding: 0; 
        }
        .container { 
          max-width: 100%; 
        }
        @page {
          margin: 1cm;
        }
      }
    </style>
  </head>
  <body>
    <div class="container">
    
      <!-- Logo reduzida -->
      <div class="logo-container">
        <img
          src="/wp-content/plugins/App/build/Logo.png"
          alt="Logo"
          class="logo"
        />
      </div>

      <div class="header">
        <h1>FICHA DE ANAMNESE</h1>
      </div>
      
      <!-- Cabeçalho com data à esquerda e título à direita -->
      <div class="cabecalho-impressao">
        <div class="data-impressao">
          Impresso em: ${dataAtual}
        </div>
        <div class="titulo-impressao">
          Ficha do Paciente - ${pacienteEditando.nome || "Impressão"}
        </div>
      </div>
      
      <!-- Informações do Paciente -->
      <div class="paciente-info">
        <h3>Informações do Paciente</h3>
        <div class="paciente-info-grid">
          <div class="paciente-info-item">
            <strong>Nome:</strong> ${pacienteEditando.nome || "---"}
          </div>
          <div class="paciente-info-item">
            <strong>CPF:</strong> ${pacienteEditando.cpf || "---"}
          </div>
          <div class="paciente-info-item">
            <strong>Telefone:</strong> ${pacienteEditando.telefone || "---"}
          </div>
          <div class="paciente-info-item">
            <strong>Email:</strong> ${pacienteEditando.email || "---"}
          </div>
        </div>
      </div>
      
      <!-- Grid de 2 colunas para ANAMNESE e Saúde Bucal -->
      <div class="grid-2-colunas">
        
        <!-- Coluna 1: ANAMNESE - Histórico de Saúde -->
        <div class="coluna">
          <div class="section">
            <div class="section-title anamnese-title">ANAMNESE - Histórico de Saúde</div>
            <div class="section-content">
              <!-- Problema de saúde -->
              <div class="campo">
                <div class="campo-label">Tem problema de saúde?</div>
                <div class="campo-valor">
                  <span class="campo-valor-booleano ${fichaData.tem_problema_saude ? "sim" : "nao"}">
                    ${formatarSimNao(fichaData.tem_problema_saude)}
                  </span>
                  ${
                    fichaData.tem_problema_saude &&
                    fichaData.qual_problema_saude
                      ? ` - ${fichaData.qual_problema_saude}`
                      : ""
                  }
                </div>
              </div>
              
              <!-- Tratamento médico -->
              <div class="campo">
                <div class="campo-label">Está em tratamento médico?</div>
                <div class="campo-valor">
                  <span class="campo-valor-booleano ${fichaData.em_tratamento_medico ? "sim" : "nao"}">
                    ${formatarSimNao(fichaData.em_tratamento_medico)}
                  </span>
                  ${
                    fichaData.em_tratamento_medico &&
                    fichaData.motivo_tratamento_medico
                      ? ` - ${fichaData.motivo_tratamento_medico}`
                      : ""
                  }
                </div>
              </div>
              
              <!-- Medicamentos -->
              <div class="campo">
                <div class="campo-label">Usa medicamento?</div>
                <div class="campo-valor">
                  <span class="campo-valor-booleano ${fichaData.usa_medicamento ? "sim" : "nao"}">
                    ${formatarSimNao(fichaData.usa_medicamento)}
                  </span>
                  ${
                    fichaData.usa_medicamento && fichaData.quais_medicamentos
                      ? ` - ${fichaData.quais_medicamentos}`
                      : ""
                  }
                </div>
              </div>
              
              <!-- Alergias -->
              <div class="campo">
                <div class="campo-label">Tem alergia a medicamento?</div>
                <div class="campo-valor">
                  <span class="campo-valor-booleano ${fichaData.alergia_medicamento ? "sim" : "nao"}">
                    ${formatarSimNao(fichaData.alergia_medicamento)}
                  </span>
                  ${
                    fichaData.alergia_medicamento && fichaData.quais_alergias
                      ? ` - ${fichaData.quais_alergias}`
                      : ""
                  }
                </div>
              </div>
              
              <!-- Pressão e Tabagismo inline para economizar espaço -->
              <div class="inline-campos">
                <div class="inline-campo">
                  <div class="campo-label">Pressão arterial</div>
                  <div class="campo-valor">${fichaData.pressao_arterial || "---"}</div>
                </div>
                <div class="inline-campo">
                  <div class="campo-label">Fumante?</div>
                  <div class="campo-valor">
                    <span class="campo-valor-booleano ${fichaData.fumante ? "sim" : "nao"}">
                      ${formatarSimNao(fichaData.fumante)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Coluna 2: Saúde Bucal e Hábitos -->
        <div class="coluna">
          <div class="section">
            <div class="section-title saude-bucal-title">Saúde Bucal e Hábitos</div>
            <div class="section-content">
              <!-- Gengivas e Sensibilidade -->
              <div class="campo">
                <div class="campo-label">Gengivas sangram com facilidade?</div>
                <div class="campo-valor">
                  <span class="campo-valor-booleano ${fichaData.gengiva_sangra ? "sim" : "nao"}">
                    ${formatarSimNao(fichaData.gengiva_sangra)}
                  </span>
                </div>
              </div>
              
              <div class="campo">
                <div class="campo-label">Tem sensibilidade nos dentes?</div>
                <div class="campo-valor">
                  <span class="campo-valor-booleano ${fichaData.sensibilidade_dentes ? "sim" : "nao"}">
                    ${formatarSimNao(fichaData.sensibilidade_dentes)}
                  </span>
                </div>
              </div>
              
              <!-- Higiene inline -->
              <div class="inline-campos">
                <div class="inline-campo">
                  <div class="campo-label">Escovações por dia</div>
                  <div class="campo-valor">${fichaData.escovacoes_por_dia || "---"}</div>
                </div>
                <div class="inline-campo">
                  <div class="campo-label">Frequência do fio dental</div>
                  <div class="campo-valor">${fichaData.frequencia_fio_dental || "---"}</div>
                </div>
              </div>
              
              <!-- Hábitos inline -->
              <div class="inline-campos">
                <div class="inline-campo">
                  <div class="campo-label">Rói unhas?</div>
                  <div class="campo-valor">
                    <span class="campo-valor-booleano ${fichaData.roi_unhas ? "sim" : "nao"}">
                      ${formatarSimNao(fichaData.roi_unhas)}
                    </span>
                  </div>
                </div>
                <div class="inline-campo">
                  <div class="campo-label">Morde lápis/caneta?</div>
                  <div class="campo-valor">
                    <span class="campo-valor-booleano ${fichaData.morde_lapis ? "sim" : "nao"}">
                      ${formatarSimNao(fichaData.morde_lapis)}
                    </span>
                  </div>
                </div>
              </div>
              
              <!-- Outros hábitos -->
              ${
                fichaData.outros_habitos
                  ? `
              <div class="campo">
                <div class="campo-label">Outros hábitos</div>
                <div class="campo-valor">${fichaData.outros_habitos}</div>
              </div>
              `
                  : ""
              }
            </div>
          </div>
        </div>
        
      </div> <!-- Fim do grid de 2 colunas -->
      
      <!-- Observações e Plano de Tratamento -->
      <div class="section">
        <div class="section-title observacoes-title">Observações e Plano de Tratamento</div>
        <div class="section-content">
          <div class="campo">
            <div class="campo-label">Observações</div>
            <div class="campo-valor" style="white-space: pre-wrap;">${fichaData.observacoes || "---"}</div>
          </div>
          
          <div class="campo" style="margin-top: 6px;">
            <div class="campo-label">Plano de Tratamento</div>
            <div class="campo-valor" style="white-space: pre-wrap;">${fichaData.plano_tratamento || "---"}</div>
          </div>
        </div>
      </div>
      
      <!-- Assinatura -->
      <div class="assinatura">
        <div class="assinatura-linha" style="margin-top: 50px;"></div>
        <p style="font-size: 9px; color: #7f8c8d;">
          Assinatura do Paciente ou Responsável
        </p>
        ${
          fichaData.data_assinatura
            ? `
        <p style="font-size: 8px; color: #95a5a6; margin-top: 2px;">
          ${new Date(fichaData.data_assinatura).toLocaleDateString("pt-BR")}
          ${
            fichaData.mes_assinatura && fichaData.ano_assinatura
              ? ` • ${fichaData.mes_assinatura}/20${fichaData.ano_assinatura}`
              : ""
          }
        </p>
        `
            : ""
        }
      </div>
    </div>
    
    <script>
      window.onload = function() {
        window.print();
      }
    </script>
  </body>
  </html>
`;

    // Escreve o conteúdo na nova janela e imprime
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  {
    /* --------------------------------------- ANEXOS --------------------------------------- */
  }

  // Função para carregar imagem via base64
  const carregarImagemBase64 = async (fotoId) => {
    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/paciente/foto/${fotoId}/download`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        },
      );

      const data = await response.json();

      if (data.success && data.data.content) {
        return `data:${data.data.tipo};base64,${data.data.content}`;
      }
      return null;
    } catch (error) {
      console.error("Erro ao carregar imagem:", error);
      return null;
    }
  };

  // Estado para armazenar as imagens carregadas
  const [imagensCarregadas, setImagensCarregadas] = useState({});

  // Estado para a imagem do visualizador
  const [imagemVisualizador, setImagemVisualizador] = useState(null);

  // Efeito para carregar imagem do visualizador
  useEffect(() => {
    if (fotoVisualizando) {
      carregarImagemBase64(fotoVisualizando.id).then((imgBase64) => {
        setImagemVisualizador(imgBase64);
      });
    } else {
      setImagemVisualizador(null);
    }
  }, [fotoVisualizando]);

  // Função para carregar todas as imagens da galeria
  const carregarTodasImagens = async (fotos) => {
    const novasImagens = {};

    for (const foto of fotos) {
      try {
        const imagemBase64 = await carregarImagemBase64(foto.id);
        if (imagemBase64) {
          novasImagens[foto.id] = imagemBase64;
        }
      } catch (error) {
        console.error(`Erro ao carregar imagem ${foto.id}:`, error);
      }
    }

    setImagensCarregadas((prev) => ({ ...prev, ...novasImagens }));
  };

  // Quando o dialog abrir
  useEffect(() => {
    if (visibleAnexos && pacienteEditando?.id) {
      handleCarregarFotosPaciente();
    }
  }, [visibleAnexos, pacienteEditando?.id]);

  const formatarTamanho = (bytes) => {
    if (bytes === 0 || !bytes) return "0 Bytes";

    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const tirarFoto = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    setFotoBase64(imageSrc);
  };

  const alternarCamera = () => {
    setTipoCamera((prev) => (prev === "environment" ? "user" : "environment"));
  };

  const abrirVisualizadorFoto = (foto) => {
    setFotoVisualizando(foto);
  };

  const fecharVisualizadorFoto = () => {
    setFotoVisualizando(null);
  };

  // depois, converter base64 -> File p/ enviar no FormData
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };

  const handleUploadArquivo = async (file) => {
    if (!file) {
      alert("Selecione um arquivo.");
      return;
    }

    setLoading(true);
    setMensagem(null);
    setErros([]);

    const formData = new FormData();
    formData.append("arquivo", file);
    formData.append("observacao", observacaoFoto); // Adicionar observação

    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/paciente/${pacienteEditando.id}/foto`, // Ajustar URL
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`,
            // Não colocar Content-Type aqui, o browser vai setar automaticamente com boundary
          },
          body: formData,
        },
      );

      const text = await response.text();
      const data = text ? JSON.parse(text) : {};

      if (!response.ok)
        throw new Error(data.message || `Erro no servidor: ${response.status}`);

      if (data.success) {
        alert("Foto enviada com sucesso!");
        setMensagem(data.message || "Foto enviada com sucesso!");
        setFotoBase64(null); // Limpar foto
        setObservacaoFoto(""); // Limpar observação
        // Opcional: recarregar lista de fotos
        // carregarFotosPaciente();
      } else {
        setMensagem(data.message || "Erro ao processar a foto.");
        alert(data.message || "Erro ao processar a foto.");
      }
    } catch (error) {
      console.error("Erro completo:", error);
      alert(error.message || "Erro ao enviar a foto.");
      setMensagem(error.message || "Erro ao enviar a foto.");
    } finally {
      setLoading(false);
    }
  };

  const handleCarregarFotosPaciente = async (pacienteId) => {
    if (!pacienteId) {
      console.log("❌ Nenhum ID de paciente fornecido");
      return;
    }

    setLoading(true);
    setErros([]);

    try {
      console.log("📸 Carregando fotos do paciente ID:", pacienteId);

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/paciente/${pacienteId}/fotos`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const text = await response.text();
      console.log("📦 Resposta bruta:", text.substring(0, 200) + "...");

      const data = text ? JSON.parse(text) : {};

      if (!response.ok) {
        throw new Error(data.message || `Erro no servidor: ${response.status}`);
      }

      if (data.success) {
        console.log(`✅ ${data.total} fotos carregadas:`, data.data);
        setFotosPaciente(data.data || []);

        // Carregar as imagens em base64
        if (data.data.length > 0) {
          await carregarTodasImagens(data.data);
        }

        if (data.total > 0) {
          setMensagem(`${data.total} foto(s) carregada(s) com sucesso!`);
        }

        return data.data;
      } else {
        throw new Error(data.message || "Erro ao carregar fotos");
      }
    } catch (error) {
      console.error("❌ Erro ao carregar fotos:", error);
      setErros([error.message || "Erro ao carregar fotos do paciente"]);
      setFotosPaciente([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const handleDeletarFoto = async (fotoId) => {
    setLoading(true);

    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/paciente/foto/${fotoId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erro ao deletar foto");
      }

      if (data.success) {
        // Remover foto da lista
        setFotosPaciente((prev) => prev.filter((foto) => foto.id !== fotoId));
        setMensagem("Foto excluída com sucesso!");
      }
    } catch (error) {
      console.error("❌ Erro ao deletar foto:", error);
      setErros([error.message]);
    } finally {
      setLoading(false);
    }
  };

  {
    /* --------------------------------------- Impressao --------------------------------------- */
  }

  const handleImprimirRecibo = (pagamentoSelecionado) => {
    const nomePaciente = pagamentoSelecionado?.paciente_nome ?? "Paciente";
    const cpfPaciente = pagamentoSelecionado?.paciente_cpf ?? "-";
    const docNumero = pagamentoSelecionado?.caixa_id ?? "-";

    const nomeDentista = pagamentoSelecionado?.profissional_nome ?? "-";
    const especDentista =
      pagamentoSelecionado?.profissional_especialidade ?? "-";

    const formaPagamento =
      pagamentoSelecionado?.pagamento_forma ?? "Não informado";

    const totalPagoNum = Number(pagamentoSelecionado?.pagamento_valor || 0);
    const totalPago = totalPagoNum.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
    });

    const dataHora = new Date();
    const dataBR = dataHora.toLocaleDateString("pt-BR");
    const horaBR = dataHora.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });

    const html = `
<!doctype html>
<html lang="pt-BR">
<head>
<meta charset="utf-8"/>
<title>Comprovante</title>

<style>
  body{font-family: monospace; display:flex; justify-content:center; background:#fff;}
  .recibo{width:320px; font-size:12px; line-height:1.35; color:#000;}
  .center{text-align:center}
  .bold{font-weight:700}
  .muted{color:#444}
  .line{border-top:1px dashed #000; margin:8px 0}
  .row{display:flex; justify-content:space-between; gap:10px; margin:2px 0}
  .title{font-size:14px; font-weight:bold; text-align:center; margin-bottom:6px}
  .total{font-size:14px; font-weight:bold; margin-top:6px}
  .small{font-size:11px}
  @media print{ body{margin:0} }
</style>
</head>

<body>
<div class="recibo">

  <div class="title">COMPROVANTE DE PAGAMENTO</div>
  <div class="center small">
    ${pagamentoSelecionado?.empresa_nome ?? "-"}<br/>
    ${pagamentoSelecionado?.empresa_cidade ?? "-"} - ${pagamentoSelecionado?.empresa_estado ?? "-"}
  </div>

  <div class="line"></div>

  <div class="row">
    <span><b>Data:</b> ${dataBR}</span>
    <span><b>Nº:</b> ${docNumero}</span>
  </div>

  <div class="line"></div>

  <div><b>Paciente:</b> ${nomePaciente}</div>
  <div><b>CPF:</b> ${cpfPaciente}</div>

  <div class="line"></div>

  <div><b>Profissional:</b> ${nomeDentista}</div>
  <div><b>Especialidade:</b> ${especDentista}</div>

  <div class="line"></div>

  <div class="bold">PAGAMENTO</div>
  <div class="row">
    <span>${formaPagamento}</span>
    <span>R$ ${totalPago}</span>
  </div>

  <div class="line"></div>

  <div class="row total">
    <span>TOTAL PAGO</span>
    <span>R$ ${totalPago}</span>
  </div>

  <div class="line"></div>

  <div class="small" style="text-align:justify">
    Confirmamos o recebimento de <b>R$ ${totalPago}</b>, pago por <b>${formaPagamento}</b>,
    referente ao registro nº <b>${docNumero}</b>. Este comprovante é emitido para fins de controle e conferência.
  </div>

</div>

<script>window.onload = () => window.print();</script>
</body>
</html>
`;

    const w = window.open(
      "",
      "_blank",
      "width=1000,height=800,left=100,top=50,scrollbars=yes",
    );
    if (!w) {
      alert("Por favor, permita pop-ups para imprimir o comprovante.");
      return;
    }

    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Dialog de Sucesso */}
      <Dialog
        visible={showSuccessDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowSuccessDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#22C55E",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setShowSuccessDialog(false)}
            className="p-button-success"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog
        visible={showErrorDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowErrorDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#EF4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-times-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            onClick={() => setShowErrorDialog(false)}
            className="p-button-danger"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog Novo */}
      <Dialog
        visible={visibleNovoPaciente}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleNovoPaciente(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUserFriends
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PACIENTE
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Nome e CPF */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaUser style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Nome do Paciente"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card CPF */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CPF *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="000.000.000-00"
                    value={cpf}
                    onChange={(e) => setCpf(e.target.value)}
                    mask="999.999.999-99"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 3ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Telefone */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaPhone style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Telefone *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="(00) 00000-0000"
                    value={telefone}
                    mask="(99) 99999-9999"
                    onChange={(e) => setTelefone(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Email */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaEnvelope
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Email *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="email@paciente.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Data Nascimento */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaUser style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Data Nascimento *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="00/00/0000"
                    value={dtNascimento}
                    onChange={(e) => setDtNascimento(e.target.value)}
                    mask="99/99/9999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 4 linha - Endereço, Número e Bairro */}
            <div className="grid-endereco-numero-bairro">
              {/* Card Endereço */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Endereço
                    </span>
                  </div>
                  <InputText
                    placeholder="Rua, Avenida, etc."
                    value={logradouro}
                    onChange={(e) => setLogradouro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Número */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #8E44AD",
                    }}
                  >
                    <FaMapPin
                      style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Número
                    </span>
                  </div>
                  <InputText
                    placeholder="Número"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Bairro */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #F1C40F",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#F1C40F", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Bairro
                    </span>
                  </div>
                  <InputText
                    placeholder="Bairro"
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 5 Linha - Cidade, Estado, CEP e Ativo */}
            <div className="grid-endereco-numero-bairro-ativo">
              {/* Card Cidade */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #27AE60",
                    }}
                  >
                    <FaCity style={{ color: "#27AE60", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Cidade
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Estado */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaGlobeAmericas
                      style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Estado
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CEP */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #95A5A6",
                    }}
                  >
                    <FaMailBulk
                      style={{ color: "#95A5A6", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CEP
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000-000"
                    value={cep}
                    onChange={(e) => setCep(e.target.value)}
                    mask="99.999-999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Ativo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheckCircle
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Ativo *
                    </span>
                  </div>
                  <Checkbox
                    checked={ativo}
                    onChange={(e) => setAtivo(e.checked)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleNovoPaciente(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CADASTRAR PACIENTE"}
              icon="pi pi-check"
              onClick={() => handleNovoPaciente(pacienteEditando)}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !validarFormulario()}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog NOVA AGENDA */}
      <Dialog
        visible={visibleAdicionar}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleAdicionar(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaCalendarCheck
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  AGENDAMENTO
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Empresa e Profissional */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #3498DB" /* Azul padrão para nome */,
                    }}
                  >
                    <FaUser style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    value={pacienteEditando.nome}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                    disabled
                  />
                </div>
              </div>

              {/* Card CPF */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CPF *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    value={pacienteEditando.cpf}
                    mask="999.999.999-99"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                    disabled
                  />
                </div>
              </div>
            </div>

            {/* 3ª Linha - Empresa e Profissional */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Empresa - VERDE ESCURO para empresa */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #16A085" /* Verde água para empresa */,
                    }}
                  >
                    <FaBuilding
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Empresa *
                    </span>
                  </div>
                  <Dropdown
                    value={empresa}
                    onChange={(e) => {
                      setEmpresa(e.value);
                      filtrarProfissionaisPorEmpresa(e.value);
                    }}
                    options={dadosCompletos.empresas.map((emp) => ({
                      label: emp.nome,
                      value: emp.id,
                    }))}
                    placeholder="Selecione a empresa"
                    className="p-inputtext-sm"
                    style={{
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      alignItems: "center",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          alignItems: "center",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              alignItems: "center",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            alignItems: "center",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>

              {/* Card Profissional - ROSA para profissional */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #8E44AD" /* Roxo mais escuro para documentos */,
                    }}
                  >
                    <FaUserMd
                      style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Profissional *
                    </span>
                  </div>
                  <Dropdown
                    value={profissional}
                    onChange={(e) => {
                      setProfissional(e.value);
                      filtrarDatasPorProfissional(e.value);
                    }}
                    options={profissionaisFiltrados}
                    placeholder="Selecione o profissional"
                    disabled={!empresa}
                    className="p-inputtext-sm"
                    style={{
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 4ª Linha - Data e Hora */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Data - VERDE para data */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #27AE60" /* Verde principal do header */,
                    }}
                  >
                    <FaCalendarAlt
                      style={{ color: "#27AE60", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Data *
                    </span>
                  </div>
                  <Dropdown
                    value={data}
                    onChange={(e) => {
                      setData(e.value);
                      filtrarHorariosPorProfissionalEData(
                        profissional,
                        e.value,
                      );
                    }}
                    options={datasDisponiveis}
                    placeholder="Selecione a data"
                    disabled={!profissional}
                    className="p-inputtext-sm"
                    style={{
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>

              {/* Card Hora - AMARELO para horário */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #F1C40F" /* Amarelo para horário */,
                    }}
                  >
                    <FaClock style={{ color: "#F1C40F", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Horário *
                    </span>
                  </div>
                  <Dropdown
                    value={hora}
                    onChange={(e) => setHora(e.value)}
                    options={horariosDisponiveis}
                    placeholder="Selecione o horário"
                    disabled={!data}
                    className="p-inputtext-sm"
                    style={{
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 5ª Linha - Serviço */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Serviço */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #e74c3c",
                    }}
                  >
                    <FaList style={{ color: "#e74c3c", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Serviço *
                    </span>
                  </div>
                  <Dropdown
                    value={servico}
                    onChange={(e) => setServico(e.value)}
                    options={servicosFiltrados}
                    placeholder="Selecione o serviço"
                    className="p-inputtext-sm"
                    disabled={!hora}
                    style={{
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleAdicionar(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CRIAR AGENDAMENTO"}
              icon="pi pi-check"
              onClick={() => handleAdicionarAgenda()}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={!hora || !servico || loading}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog FICHA PACIENTE */}
      <Dialog
        visible={visibleFicha}
        style={{
          width: "90vw",
          maxWidth: "1030px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        contentStyle={{
          overflowY: "auto",
          overflowX: "hidden",
          maxHeight: "80vh",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleFicha(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaCalendarCheck
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  FICHA DO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PACIENTE
                </div>
              </div>
              <div
                style={{
                  padding: "0 20px",
                }}
              >
                <Button
                  icon="pi pi-print"
                  onClick={handleImprimirFicha}
                  className="p-button-outlined p-button-sm"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    padding: "8px 24px",
                    minWidth: "40px",
                    borderColor: "#dee2e6",
                    color: "#495057",
                    fontWeight: "500",
                    fontSize: "0.875rem",
                  }}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards - Mesmo estilo dos outros dialogs */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Informações do Paciente e Estatísticas */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Informações do Paciente */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498db",
                    }}
                  >
                    <FaUser style={{ color: "#3498db", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Informações do Paciente
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      fontSize: "0.9rem",
                      color: "#34495e",
                    }}
                  >
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Nome:
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {pacienteEditando.nome}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        CPF:
                      </span>
                      <span>{pacienteEditando.cpf}</span>
                    </div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Telefone:
                      </span>
                      <span>{pacienteEditando.telefone}</span>
                    </div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Email:
                      </span>
                      <span>{pacienteEditando.email}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Estatísticas */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2ecc71",
                    }}
                  >
                    <FaChartBar
                      style={{ color: "#2ecc71", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Estatísticas
                    </span>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "5px",
                    }}
                  >
                    {/* Quadro Atendimentos */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginBottom: "4px",
                        }}
                      >
                        <FaFileMedical
                          style={{ color: "#3498db", fontSize: "0.8rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.8rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Atendimentos
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "#3498db",
                          fontSize: "0.85rem",
                          textAlign: "center",
                          lineHeight: "1",
                        }}
                      >
                        {
                          pacienteEscolhido.filter(
                            (p) =>
                              p.status === "confirmado" ||
                              p.status === "realizado",
                          ).length
                        }
                      </div>
                    </div>

                    {/* Quadro Próxima Consulta */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginBottom: "4px",
                        }}
                      >
                        <FaCalendarPlus
                          style={{ color: "#2ecc71", fontSize: "0.8rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.8rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Próxima Agenda
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "#2ecc71",
                          fontSize: "0.85rem",
                          textAlign: "center",
                          lineHeight: "1",
                        }}
                      >
                        {(() => {
                          const confirmados = pacienteEscolhido.filter(
                            (item) => item.status === "confirmado",
                          );

                          if (!confirmados.length) return "-";

                          // pega o mais recente
                          const maisRecente = confirmados.reduce(
                            (prev, curr) =>
                              new Date(curr.data_atendimento) <
                              new Date(prev.data_atendimento)
                                ? curr
                                : prev,
                          );

                          return new Date(
                            maisRecente.data_atendimento,
                          ).toLocaleDateString("pt-BR");
                        })()}
                      </div>
                    </div>

                    {/* Quadro status da ANAMNESE */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginBottom: "4px",
                        }}
                      >
                        <FaHeartbeat
                          style={{ color: "#27ae60", fontSize: "0.8rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.8rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Anamnese
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          textAlign: "center",
                          lineHeight: "1",
                          color: (() => {
                            // Verifica se pelo menos um campo da anamnese está preenchido
                            const temAnamnese =
                              fichaData.tem_problema_saude ||
                              fichaData.em_tratamento_medico ||
                              fichaData.usa_medicamento ||
                              fichaData.alergia_medicamento ||
                              fichaData.pressao_arterial ||
                              fichaData.fumante ||
                              fichaData.qual_problema_saude ||
                              fichaData.motivo_tratamento_medico ||
                              fichaData.quais_medicamentos ||
                              fichaData.quais_alergias;

                            return temAnamnese ? "#27ae60" : "#e74c3c";
                          })(),
                        }}
                      >
                        {(() => {
                          // Verifica se pelo menos um campo da anamnese está preenchido
                          const temAnamnese =
                            fichaData.tem_problema_saude ||
                            fichaData.em_tratamento_medico ||
                            fichaData.usa_medicamento ||
                            fichaData.alergia_medicamento ||
                            fichaData.pressao_arterial ||
                            fichaData.fumante ||
                            fichaData.qual_problema_saude ||
                            fichaData.motivo_tratamento_medico ||
                            fichaData.quais_medicamentos ||
                            fichaData.quais_alergias;

                          return temAnamnese ? "COMPLETO" : "INCOMPLETO";
                        })()}
                      </div>
                    </div>

                    {/* Quadro status da SAÚDE BUCAL */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginBottom: "4px",
                        }}
                      >
                        <FaTooth
                          style={{ color: "#e67e22", fontSize: "0.8rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.8rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Saúde Bucal
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          textAlign: "center",
                          lineHeight: "1",
                          color: (() => {
                            // Verifica se pelo menos um campo da saúde bucal está preenchido
                            const temSaudeBucal =
                              fichaData.gengiva_sangra ||
                              fichaData.sensibilidade_dentes ||
                              fichaData.escovacoes_por_dia ||
                              fichaData.frequencia_fio_dental ||
                              fichaData.roi_unhas ||
                              fichaData.morde_lapis ||
                              fichaData.outros_habitos;

                            return temSaudeBucal ? "#e67e22" : "#e74c3c";
                          })(),
                        }}
                      >
                        {(() => {
                          // Verifica se pelo menos um campo da saúde bucal está preenchido
                          const temSaudeBucal =
                            fichaData.gengiva_sangra ||
                            fichaData.sensibilidade_dentes ||
                            fichaData.escovacoes_por_dia ||
                            fichaData.frequencia_fio_dental ||
                            fichaData.roi_unhas ||
                            fichaData.morde_lapis ||
                            fichaData.outros_habitos;

                          return temSaudeBucal ? "COMPLETO" : "INCOMPLETO";
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Container das Seções com setas */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                width: "100%",
              }}
            >
              {/* SEÇÃO 1 - ODONTOGRAMA (AGORA COM SETA) */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                {/* Cabeçalho da Seção - com seta igual às outras seções */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 15px",
                    cursor: "pointer",
                    borderBottom: secoesExpandidas.includes("odontograma")
                      ? "1px solid #e8e8e8"
                      : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => alternarSecao("odontograma")}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaTooth style={{ color: "#e74c3c", fontSize: "1rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Odontograma
                    </span>
                  </div>

                  <Button
                    icon={
                      secoesExpandidas.includes("odontograma")
                        ? "pi pi-chevron-up"
                        : "pi pi-chevron-down"
                    }
                    className="p-button-text p-button-sm"
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#495057",
                      backgroundColor: secoesExpandidas.includes("odontograma")
                        ? "#f0f0f0"
                        : "transparent",
                      outline: "none",
                      boxShadow: "none",
                      borderRadius: "4px",
                      border: "1px solid #dee2e6",
                    }}
                  />
                </div>

                {/* Conteúdo da Seção (expansível) */}
                {secoesExpandidas.includes("odontograma") && (
                  <div style={{ padding: "15px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            backgroundColor: "#fff",
                            padding: "8px",
                            borderRadius: "8px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <Button
                            label="Adulto"
                            icon={tipoDente === "adulto" ? "pi pi-check" : ""}
                            onClick={() => setTipoDente("adulto")}
                            className="p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              padding: "6px 25px",
                              minWidth: "120px",
                              backgroundColor:
                                tipoDente === "adulto"
                                  ? "#3498db"
                                  : "transparent",
                              borderColor:
                                tipoDente === "adulto" ? "#3498db" : "#dee2e6",
                              color:
                                tipoDente === "adulto" ? "white" : "#495057",
                              fontWeight: "600",
                              fontSize: "0.9rem",
                              fontFamily: "'Rajdhani', sans-serif",
                            }}
                          />
                          <Button
                            label="Criança"
                            icon={tipoDente === "infantil" ? "pi pi-check" : ""}
                            onClick={() => setTipoDente("infantil")}
                            className="p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              padding: "6px 25px",
                              minWidth: "120px",
                              backgroundColor:
                                tipoDente === "infantil"
                                  ? "#3498db"
                                  : "transparent",
                              borderColor:
                                tipoDente === "infantil"
                                  ? "#3498db"
                                  : "#dee2e6",
                              color:
                                tipoDente === "infantil" ? "white" : "#495057",
                              fontWeight: "600",
                              fontSize: "0.9rem",
                              fontFamily: "'Rajdhani', sans-serif",
                            }}
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          overflow: "hidden",
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            overflowX: "auto",
                            overflowY: "hidden",
                            width: "100%",
                            WebkitOverflowScrolling: "touch",
                            touchAction: "pan-x",
                            display: "flex",
                            justifyContent: "center",
                          }}
                          className="hide-scrollbar"
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              maxWidth: "100%",
                              transform: "scale(0.8)",
                              transformOrigin: "center",
                            }}
                          >
                            {tipoDente === "adulto" ? (
                              <DentesAdultoMemo
                                historicoDentes={historicoDentesMap}
                              />
                            ) : (
                              <DentesInfantilMemo
                                historicoDentes={historicoDentesMap}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          width: "70%",
                          margin: "0 auto",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            maxHeight: "180px",
                            overflowY: "auto",
                          }}
                        >
                          {pacienteEscolhido &&
                          pacienteEscolhido.filter((item) => item.dentes)
                            .length > 0 ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {pacienteEscolhido
                                .filter((item) => item.dentes)
                                .map((item, index) => {
                                  let dentesList = [];
                                  if (item.dentes) {
                                    dentesList = item.dentes
                                      .split(",")
                                      .map((dente) => ({
                                        nome: dente.trim(),
                                        situacao: item.situacao,
                                      }));
                                  }

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "5px 10px",
                                        borderBottom:
                                          index <
                                          pacienteEscolhido.filter(
                                            (item) => item.dentes,
                                          ).length -
                                            1
                                            ? "1px solid #e9ecef"
                                            : "none",
                                        backgroundColor:
                                          index % 2 === 0
                                            ? "#ffffff"
                                            : "#f8f9fa",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        fontSize: "0.8rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          minWidth: "80px",
                                          color: "#495057",
                                          fontWeight: "500",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {item.data_realizacao
                                          ? new Date(
                                              item.data_realizacao,
                                            ).toLocaleDateString("pt-BR", {
                                              day: "2-digit",
                                              month: "2-digit",
                                            })
                                          : new Date(
                                              item.data_atendimento,
                                            ).toLocaleDateString("pt-BR", {
                                              day: "2-digit",
                                              month: "2-digit",
                                            })}
                                        {item.horario && (
                                          <span
                                            style={{
                                              color: "#6c757d",
                                              marginLeft: "4px",
                                            }}
                                          >
                                            - {item.horario.substring(0, 5)}
                                          </span>
                                        )}
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "3px",
                                          minWidth: "100px",
                                        }}
                                      >
                                        {dentesList.map((dente, i) => (
                                          <span
                                            key={i}
                                            style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "2px",
                                              padding: "2px 5px",
                                              borderRadius: "4px",
                                              fontSize: "0.7rem",
                                              fontWeight: "500",
                                              backgroundColor:
                                                dente.situacao === "1"
                                                  ? "#e3f2fd"
                                                  : dente.situacao === "2"
                                                    ? "#ffebee"
                                                    : "#f8f9fa",
                                              color:
                                                dente.situacao === "1"
                                                  ? "#1976d2"
                                                  : dente.situacao === "2"
                                                    ? "#c62828"
                                                    : "#6c757d",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <FaTooth
                                              style={{ fontSize: "0.55rem" }}
                                            />
                                            {dente.nome}
                                          </span>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          flex: 1,
                                          color: "#495057",
                                          fontSize: "0.75rem",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        title={
                                          item.procedimento_descricao ||
                                          item.servico_descricao
                                        }
                                      >
                                        {item.procedimento_descricao ||
                                          item.servico_descricao}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                padding: "15px",
                                backgroundColor: "#fafafa",
                              }}
                            >
                              <FaTooth
                                style={{ fontSize: "1rem", color: "#adb5bd" }}
                              />
                              <span
                                style={{ fontSize: "0.8rem", color: "#6c757d" }}
                              >
                                Nenhum procedimento com dentes
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* SEÇÃO 2 - ANAMNESE */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                {/* Cabeçalho da Seção - com seta igual ao Histórico */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 15px",
                    cursor: "pointer",
                    borderBottom: secoesExpandidas.includes("anamnese")
                      ? "1px solid #e8e8e8"
                      : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => alternarSecao("anamnese")}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaHeartbeat
                      style={{ color: "#27ae60", fontSize: "1rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Histórico de Saúde
                    </span>
                  </div>

                  <Button
                    icon={
                      secoesExpandidas.includes("anamnese")
                        ? "pi pi-chevron-up"
                        : "pi pi-chevron-down"
                    }
                    className="p-button-text p-button-sm"
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#495057",
                      backgroundColor: secoesExpandidas.includes("anamnese")
                        ? "#f0f0f0"
                        : "transparent",
                      outline: "none",
                      boxShadow: "none",
                      borderRadius: "4px",
                      border: "1px solid #dee2e6",
                    }}
                  />
                </div>

                {/* Conteúdo da Seção (expansível) */}
                {secoesExpandidas.includes("anamnese") && (
                  <div style={{ padding: "15px" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "5px",
                      }}
                    >
                      {/* Card ANAMNESE */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          width: "100%",
                        }}
                      >
                        {/* Problemas de Saúde */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Problemas de saúde?
                            </span>
                            <Dropdown
                              id="tem_problema_saude"
                              value={fichaData.tem_problema_saude || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  tem_problema_saude: newValue,
                                  qual_problema_saude:
                                    newValue === "Sim"
                                      ? fichaData.qual_problema_saude
                                      : "",
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>

                          {fichaData.tem_problema_saude === "Sim" && (
                            <div style={{ marginTop: "12px" }}>
                              <InputTextarea
                                id="qual_problema_saude"
                                value={fichaData.qual_problema_saude || ""}
                                onChange={(e) =>
                                  setFichaData({
                                    ...fichaData,
                                    qual_problema_saude: e.target.value,
                                  })
                                }
                                rows={2}
                                style={{
                                  width: "100%",
                                  fontSize: "0.85rem",
                                  backgroundColor: "#fff8e1",
                                  border: "1px solid #ffecb3",
                                  fontFamily: "'Rajdhani', sans-serif",
                                }}
                                autoResize
                                placeholder="Descreva o(s) problema(s)"
                              />
                            </div>
                          )}
                        </div>

                        {/* Em tratamento médico? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                                lineHeight: "normal",
                              }}
                            >
                              Em tratamento médico?
                            </span>
                            <Dropdown
                              id="em_tratamento_medico"
                              value={fichaData.em_tratamento_medico || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  em_tratamento_medico: newValue,
                                  motivo_tratamento_medico:
                                    newValue === "Sim"
                                      ? fichaData.motivo_tratamento_medico
                                      : "",
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>

                          {fichaData.em_tratamento_medico === "Sim" && (
                            <div style={{ marginTop: "12px" }}>
                              <InputTextarea
                                id="motivo_tratamento_medico"
                                value={fichaData.motivo_tratamento_medico || ""}
                                onChange={(e) =>
                                  setFichaData({
                                    ...fichaData,
                                    motivo_tratamento_medico: e.target.value,
                                  })
                                }
                                rows={2}
                                style={{
                                  width: "100%",
                                  fontSize: "0.85rem",
                                  backgroundColor: "#fff8e1",
                                  border: "1px solid #ffecb3",
                                  fontFamily: "'Rajdhani', sans-serif",
                                }}
                                autoResize
                                placeholder="Motivo do tratamento"
                              />
                            </div>
                          )}
                        </div>

                        {/* Usa medicamentos? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                                lineHeight: "normal",
                              }}
                            >
                              Usa medicamentos?
                            </span>
                            <Dropdown
                              id="usa_medicamento"
                              value={fichaData.usa_medicamento || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  usa_medicamento: newValue,
                                  quais_medicamentos:
                                    newValue === "Sim"
                                      ? fichaData.quais_medicamentos
                                      : "",
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>

                          {fichaData.usa_medicamento === "Sim" && (
                            <div style={{ marginTop: "12px" }}>
                              <InputTextarea
                                id="quais_medicamentos"
                                value={fichaData.quais_medicamentos || ""}
                                onChange={(e) =>
                                  setFichaData({
                                    ...fichaData,
                                    quais_medicamentos: e.target.value,
                                  })
                                }
                                rows={2}
                                style={{
                                  width: "100%",
                                  fontSize: "0.85rem",
                                  backgroundColor: "#fff8e1",
                                  border: "1px solid #ffecb3",
                                  fontFamily: "'Rajdhani', sans-serif",
                                }}
                                autoResize
                                placeholder="Qual(is) medicamento(s)?"
                              />
                            </div>
                          )}
                        </div>

                        {/* Alergia a medicamentos? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                                lineHeight: "normal",
                              }}
                            >
                              Alergia a medicamentos?
                            </span>
                            <Dropdown
                              id="alergia_medicamento"
                              value={fichaData.alergia_medicamento || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  alergia_medicamento: newValue,
                                  quais_alergias:
                                    newValue === "Sim"
                                      ? fichaData.quais_alergias
                                      : "",
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>

                          {fichaData.alergia_medicamento === "Sim" && (
                            <div style={{ marginTop: "12px" }}>
                              <InputTextarea
                                id="quais_alergias"
                                value={fichaData.quais_alergias || ""}
                                onChange={(e) =>
                                  setFichaData({
                                    ...fichaData,
                                    quais_alergias: e.target.value,
                                  })
                                }
                                rows={2}
                                style={{
                                  width: "100%",
                                  fontSize: "0.85rem",
                                  backgroundColor: "#fff8e1",
                                  border: "1px solid #ffecb3",
                                  fontFamily: "'Rajdhani', sans-serif",
                                }}
                                autoResize
                                placeholder="Qual(is)? (antibiótico, anestésico, etc)"
                              />
                            </div>
                          )}
                        </div>

                        {/* É ou já foi fumante? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                                lineHeight: "normal",
                              }}
                            >
                              É ou já foi fumante?
                            </span>
                            <Dropdown
                              id="fumante"
                              value={fichaData.fumante || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  fumante: newValue,
                                  tempo_fumante:
                                    newValue === "Sim"
                                      ? fichaData.tempo_fumante
                                      : "",
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>

                          {fichaData.fumante === "Sim" && (
                            <div style={{ marginTop: "12px" }}>
                              <InputTextarea
                                id="tempo_fumante"
                                value={fichaData.tempo_fumante || ""}
                                onChange={(e) =>
                                  setFichaData({
                                    ...fichaData,
                                    tempo_fumante: e.target.value,
                                  })
                                }
                                rows={2}
                                style={{
                                  width: "100%",
                                  fontSize: "0.85rem",
                                  backgroundColor: "#fff8e1",
                                  border: "1px solid #ffecb3",
                                  fontFamily: "'Rajdhani', sans-serif",
                                }}
                                autoResize
                                placeholder="Há quanto tempo? Quantos cigarros por dia?"
                              />
                            </div>
                          )}
                        </div>

                        {/* Pressão arterial - mantido separado pois é um campo diferente */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              marginBottom: "4px",
                              fontSize: "0.8rem",
                              color: "#7f8c8d",
                            }}
                          >
                            Pressão arterial habitual
                          </div>
                          <InputText
                            id="pressao_arterial"
                            value={fichaData.pressao_arterial || ""}
                            onChange={(e) =>
                              setFichaData({
                                ...fichaData,
                                pressao_arterial: e.target.value,
                              })
                            }
                            style={{
                              width: "100%",
                              fontSize: "0.85rem",
                              height: "30px",
                              fontFamily: "'Rajdhani', sans-serif",
                            }}
                            placeholder="Ex: 12x8"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* SEÇÃO 3 - SAÚDE BUCAL E HÁBITOS */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                {/* Cabeçalho da Seção - com seta igual ao Histórico/Anamnese */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 15px",
                    cursor: "pointer",
                    borderBottom: secoesExpandidas.includes("saude_bucal")
                      ? "1px solid #e8e8e8"
                      : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => alternarSecao("saude_bucal")}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaTooth style={{ color: "#e67e22", fontSize: "1rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Saúde Bucal e Hábitos
                    </span>
                  </div>

                  <Button
                    icon={
                      secoesExpandidas.includes("saude_bucal")
                        ? "pi pi-chevron-up"
                        : "pi pi-chevron-down"
                    }
                    className="p-button-text p-button-sm"
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#495057",
                      backgroundColor: secoesExpandidas.includes("saude_bucal")
                        ? "#f0f0f0"
                        : "transparent",
                      outline: "none",
                      boxShadow: "none",
                      borderRadius: "4px",
                      border: "1px solid #dee2e6",
                    }}
                  />
                </div>

                {/* Conteúdo da Seção (expansível) */}
                {secoesExpandidas.includes("saude_bucal") && (
                  <div style={{ padding: "15px" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "5px",
                      }}
                    >
                      {/* Container dos cards */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          width: "100%",
                        }}
                      >
                        {/* Gengivas sangram? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Gengivas sangram com facilidade?
                            </span>
                            <Dropdown
                              id="gengiva_sangra"
                              value={fichaData.gengiva_sangra || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  gengiva_sangra: newValue,
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>
                        </div>

                        {/* Sensibilidade dentária */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Tem sensibilidade nos dentes?
                            </span>
                            <Dropdown
                              id="sensibilidade_dentes"
                              value={fichaData.sensibilidade_dentes || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  sensibilidade_dentes: newValue,
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>
                        </div>

                        {/* Escovações por dia */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Escovações por dia?
                            </span>
                            <InputText
                              className="p-inputtext-sm"
                              placeholder="Qtd"
                              value={fichaData.escovacoes_por_dia || ""}
                              onChange={(e) =>
                                setFichaData({
                                  ...fichaData,
                                  escovacoes_por_dia: e.target.value,
                                })
                              }
                              style={{
                                width: "100px",
                                height: "25px",
                                fontSize: "0.75rem",
                                textAlign: "center",
                                fontFamily: "'Rajdhani', sans-serif",
                              }}
                              keyfilter="int"
                              maxLength={2}
                            />
                          </div>
                        </div>

                        {/* Frequência do fio dental */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Frequência do fio dental?
                            </span>
                            <Dropdown
                              id="frequencia_fio_dental"
                              value={fichaData.frequencia_fio_dental || ""}
                              onChange={(e) =>
                                setFichaData({
                                  ...fichaData,
                                  frequencia_fio_dental: e.value,
                                })
                              }
                              options={[
                                { label: "Diariamente", value: "Diariamente" },
                                { label: "Às vezes", value: "As vezes" },
                                { label: "Raramente", value: "Raramente" },
                                { label: "Não usa", value: "Nao usa" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "150px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>
                        </div>

                        {/* Rói unhas? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Rói unhas?
                            </span>
                            <Dropdown
                              id="roi_unhas"
                              value={fichaData.roi_unhas || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  roi_unhas: newValue,
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>
                        </div>

                        {/* Morde lápis/caneta? */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#34495e",
                                fontWeight: "500",
                              }}
                            >
                              Morde lápis/caneta?
                            </span>
                            <Dropdown
                              id="morde_lapis"
                              value={fichaData.morde_lapis || "Não"}
                              onChange={(e) => {
                                const newValue = e.value;
                                setFichaData({
                                  ...fichaData,
                                  morde_lapis: newValue,
                                });
                              }}
                              options={[
                                { label: "Sim", value: "Sim" },
                                { label: "Não", value: "Não" },
                              ]}
                              placeholder="Selecione"
                              className="p-inputtext-sm"
                              style={{
                                width: "100px",
                                height: "25px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              panelStyle={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                              itemTemplate={(option) => (
                                <span
                                  style={{
                                    fontFamily: "'Rajdhani', sans-serif",
                                    fontSize: "0.9rem",
                                    display: "block",
                                  }}
                                >
                                  {option.label}
                                </span>
                              )}
                              valueTemplate={(option, props) => {
                                if (!option)
                                  return (
                                    <span
                                      style={{
                                        fontFamily: "'Rajdhani', sans-serif",
                                        fontSize: "0.9rem",
                                        color: "#7f8c8d",
                                        margin: "0",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        lineHeight: "normal",
                                      }}
                                    >
                                      {props.placeholder}
                                    </span>
                                  );
                                return (
                                  <span
                                    style={{
                                      fontFamily: "'Rajdhani', sans-serif",
                                      fontSize: "0.9rem",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "100%",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {option.label}
                                  </span>
                                );
                              }}
                            />
                          </div>
                        </div>

                        {/* Outros hábitos */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              marginBottom: "8px",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              color: "#34495e",
                            }}
                          >
                            Outros hábitos
                          </div>
                          <InputTextarea
                            id="outros_habitos"
                            value={fichaData.outros_habitos || ""}
                            onChange={(e) =>
                              setFichaData({
                                ...fichaData,
                                outros_habitos: e.target.value,
                              })
                            }
                            rows={2}
                            style={{
                              width: "100%",
                              fontSize: "0.85rem",
                              fontFamily: "'Rajdhani', sans-serif",
                              backgroundColor: "#fafafa",
                              border: "1px solid #e0e0e0",
                            }}
                            autoResize
                            placeholder="Outros hábitos? (ex: bruxismo, roer objetos, etc)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* SEÇÃO 4 - OBSERVAÇÕES E PLANO DE TRATAMENTO */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                {/* Cabeçalho da Seção */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 15px",
                    cursor: "pointer",
                    borderBottom: secoesExpandidas.includes("observacoes")
                      ? "1px solid #e8e8e8"
                      : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => alternarSecao("observacoes")}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaFileAlt style={{ color: "#8e44ad", fontSize: "1rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Observações e Plano de Tratamento
                    </span>
                  </div>

                  <Button
                    icon={
                      secoesExpandidas.includes("observacoes")
                        ? "pi pi-chevron-up"
                        : "pi pi-chevron-down"
                    }
                    className="p-button-text p-button-sm"
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#495057",
                      backgroundColor: secoesExpandidas.includes("observacoes")
                        ? "#f0f0f0"
                        : "transparent",
                      outline: "none",
                      boxShadow: "none",
                      borderRadius: "4px",
                      border: "1px solid #dee2e6",
                    }}
                  />
                </div>

                {/* Conteúdo da Seção */}
                {secoesExpandidas.includes("observacoes") && (
                  <div style={{ padding: "15px" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "5px",
                      }}
                    >
                      {/* Card OBSERVAÇÕES - sem header interno */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          width: "100%",
                        }}
                      >
                        {/* Observações */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <InputTextarea
                            id="observacoes"
                            value={fichaData.observacoes || ""}
                            onChange={(e) =>
                              setFichaData({
                                ...fichaData,
                                observacoes: e.target.value,
                              })
                            }
                            rows={2}
                            style={{
                              width: "100%",
                              fontSize: "0.85rem",
                              fontFamily: "'Rajdhani', sans-serif",
                              backgroundColor: "#fafafa",
                              border: "1px solid #e0e0e0",
                            }}
                            autoResize
                            placeholder="Observações gerais"
                          />
                        </div>

                        {/* Plano de Tratamento */}
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "10px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <InputTextarea
                            id="plano_tratamento"
                            value={fichaData.plano_tratamento || ""}
                            onChange={(e) =>
                              setFichaData({
                                ...fichaData,
                                plano_tratamento: e.target.value,
                              })
                            }
                            rows={2}
                            style={{
                              width: "100%",
                              fontSize: "0.85rem",
                              fontFamily: "'Rajdhani', sans-serif",
                              backgroundColor: "#fafafa",
                              border: "1px solid #e0e0e0",
                            }}
                            autoResize
                            placeholder="Plano de Tratamento"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Botões */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
              marginTop: "15px",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleFicha(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "SALVAR FICHA"}
              icon="pi pi-check"
              onClick={handleSalvarFicha}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              loading={loading}
            />
          </div>
        </>
      </Dialog>
      {/* Dialog EDITAR */}
      <Dialog
        visible={visibleEditar}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleEditar(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUserFriends
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  EDITAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PACIENTE
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Nome e CPF */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaUser style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Nome do Paciente"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card CPF */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CPF *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="000.000.000-00"
                    value={cpf}
                    onChange={(e) => setCpf(e.target.value)}
                    mask="999.999.999-99"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 3ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Telefone */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaPhone style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Telefone *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="(00) 00000-0000"
                    value={telefone}
                    mask="(99) 99999-9999"
                    onChange={(e) => setTelefone(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Email */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaEnvelope
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Email *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="email@paciente.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Data Nascimento */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaUser style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Data Nascimento *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="00/00/0000"
                    value={dtNascimento}
                    onChange={(e) => setDtNascimento(e.target.value)}
                    mask="99/99/9999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 4 linha - Endereço, Número e Bairro */}
            <div className="grid-endereco-numero-bairro">
              {/* Card Endereço */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Endereço
                    </span>
                  </div>
                  <InputText
                    placeholder="Rua, Avenida, etc."
                    value={logradouro}
                    onChange={(e) => setLogradouro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Número */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #8E44AD",
                    }}
                  >
                    <FaMapPin
                      style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Número
                    </span>
                  </div>
                  <InputText
                    placeholder="Número"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Bairro */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #F1C40F",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#F1C40F", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Bairro
                    </span>
                  </div>
                  <InputText
                    placeholder="Bairro"
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 5 Linha - Cidade, Estado, CEP e Ativo */}
            <div className="grid-endereco-numero-bairro-ativo">
              {/* Card Cidade */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #27AE60",
                    }}
                  >
                    <FaCity style={{ color: "#27AE60", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Cidade
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Estado */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaGlobeAmericas
                      style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Estado
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CEP */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #95A5A6",
                    }}
                  >
                    <FaMailBulk
                      style={{ color: "#95A5A6", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CEP
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000-000"
                    value={cep}
                    onChange={(e) => setCep(e.target.value)}
                    mask="99.999-999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Ativo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheckCircle
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Ativo *
                    </span>
                  </div>
                  <Checkbox
                    checked={ativo}
                    onChange={(e) => setAtivo(e.checked)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleEditar(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
              icon="pi pi-check"
              onClick={() => handleEditar(pacienteEditando)}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !validarFormulario()}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog do Histórico */}
      <Dialog
        visible={visibleHistorico}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => setVisibleHistorico(false)}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUserFriends
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  HISTÓRICO DO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PACIENTE
                </div>
              </div>
            </div>
          </div>
        }
      >
        {pacienteEditando && pacienteEscolhido && (
          <>
            {/* Formulário em Cards - Mesmo estilo dos outros dialogs */}
            <div style={{ padding: "10px 0" }}>
              {/* 1ª Linha - Informações do Paciente e Estatísticas */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                {/* Card Informações do Paciente */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498db",
                      }}
                    >
                      <FaUser
                        style={{ color: "#3498db", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Informações do Paciente
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        fontSize: "0.9rem",
                        color: "#34495e",
                      }}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Nome:
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {pacienteEditando.nome}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          CPF:
                        </span>
                        <span>{pacienteEditando.cpf}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Telefone:
                        </span>
                        <span>{pacienteEditando.telefone}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Email:
                        </span>
                        <span>{pacienteEditando.email}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Estatísticas */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2ecc71",
                      }}
                    >
                      <FaChartBar
                        style={{ color: "#2ecc71", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Estatísticas
                      </span>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "5px",
                      }}
                    >
                      {/* Quadro Atendimentos */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaFileMedical
                            style={{ color: "#3498db", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Atendimentos
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#3498db",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {
                            new Set(
                              pacienteEscolhido
                                .filter(
                                  (p) =>
                                    p.status === "confirmado" ||
                                    p.status === "realizado",
                                )
                                .map((p) => p.agendamento_id),
                            ).size
                          }
                        </div>
                      </div>

                      {/* Quadro Próxima Consulta */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaCalendarPlus
                            style={{ color: "#2ecc71", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Próxima Agenda
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#2ecc71",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {(() => {
                            const confirmados = pacienteEscolhido.filter(
                              (item) => item.status === "confirmado",
                            );

                            if (!confirmados.length) return "-";

                            // pega o mais recente
                            const maisRecente = confirmados.reduce(
                              (prev, curr) =>
                                new Date(curr.data_atendimento) <
                                new Date(prev.data_atendimento)
                                  ? curr
                                  : prev,
                            );

                            return new Date(
                              maisRecente.data_atendimento,
                            ).toLocaleDateString("pt-BR");
                          })()}
                        </div>
                      </div>

                      {/* Quadro Última Visita */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaCalendarCheck
                            style={{ color: "#f39c12", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Última Visita
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#f39c12",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {pacienteEscolhido.filter(
                            (p) => p.status === "realizado",
                          ).length > 0
                            ? new Date(
                                pacienteEscolhido.filter(
                                  (p) => p.status === "realizado",
                                )[0].data_realizacao,
                              ).toLocaleDateString("pt-BR")
                            : "-"}
                        </div>
                      </div>

                      {/* Quadro Último Procedimento */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaTooth
                            style={{ color: "#e74c3c", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Últ. Procedimento
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#e74c3c",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {pacienteEscolhido.filter(
                            (p) => p.status === "realizado",
                          ).length > 0
                            ? pacienteEscolhido.filter(
                                (p) => p.status === "realizado",
                              )[0].dentes
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2ª Linha - Histórico de Procedimentos */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2ecc71",
                      }}
                    >
                      <FaHistory
                        style={{ color: "#2ecc71", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Histórico de Procedimentos
                      </span>
                    </div>

                    <div
                      style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        paddingRight: "5px",
                      }}
                    >
                      {pacienteEscolhido.filter(
                        (procedimento) => procedimento.status === "realizado",
                      ).length === 0 ? (
                        // Exibe a mensagem quando não houver procedimentos
                        <div
                          style={{
                            padding: "20px",
                            textAlign: "center",
                            color: "#7f8c8d",
                          }}
                        >
                          <FaUser
                            style={{
                              fontSize: "2rem",
                              color: "#adb5bd",
                              marginBottom: "10px",
                              opacity: 0.5,
                            }}
                          />
                          <div
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.85rem",
                              fontSize: "0.9rem",
                            }}
                          >
                            Nenhum Histórico encontrado para este paciente
                          </div>
                        </div>
                      ) : (
                        // Agrupa os procedimentos por agendamento_id
                        Object.values(
                          pacienteEscolhido
                            .filter(
                              (procedimento) =>
                                procedimento.status === "realizado",
                            )
                            .reduce((agrupados, procedimento) => {
                              const agendamentoId = procedimento.agendamento_id;

                              if (!agrupados[agendamentoId]) {
                                // Primeiro procedimento deste agendamento
                                agrupados[agendamentoId] = {
                                  agendamento_id: agendamentoId,
                                  data_realizacao: procedimento.data_realizacao,
                                  data_atualizacao:
                                    procedimento.data_atualizacao, // 👈 ADD
                                  data_atendimento:
                                    procedimento.data_atendimento, // 👈 ADD
                                  profissional_nome:
                                    procedimento.profissional_nome,
                                  empresa_nome: procedimento.empresa_nome,
                                  queixas: procedimento.queixas,
                                  servico_descricao:
                                    procedimento.servico_descricao,
                                  procedimento_observacoes:
                                    procedimento.procedimento_observacoes,
                                  servicos_extras:
                                    procedimento.servicos_extras || [],
                                  dentes: [],
                                  procedimentos: [],
                                  condicao: procedimento.condicao,
                                };
                              }

                              // Adiciona o dente e o procedimento
                              if (procedimento.dentes) {
                                agrupados[agendamentoId].dentes.push(
                                  procedimento.dentes,
                                );
                              }

                              agrupados[agendamentoId].procedimentos.push({
                                procedimento_id: procedimento.procedimento_id,
                                dentes: procedimento.dentes,
                                condicao: procedimento.condicao,
                                procedimento_descricao:
                                  procedimento.procedimento_descricao,
                              });

                              // Mescla serviços extras (evitando duplicatas)
                              if (
                                procedimento.servicos_extras &&
                                procedimento.servicos_extras.length > 0
                              ) {
                                procedimento.servicos_extras.forEach(
                                  (servicoExtra) => {
                                    const existe = agrupados[
                                      agendamentoId
                                    ].servicos_extras.some(
                                      (s) => s.id === servicoExtra.id,
                                    );
                                    if (!existe) {
                                      agrupados[
                                        agendamentoId
                                      ].servicos_extras.push(servicoExtra);
                                    }
                                  },
                                );
                              }

                              return agrupados;
                            }, {}),
                        ).map((agendamento, index) => {
                          const isExpandido = itensExpandidos.includes(
                            `agendamento_${agendamento.agendamento_id}`,
                          );

                          return (
                            <div
                              key={`agendamento_${agendamento.agendamento_id || index}`}
                              style={{
                                backgroundColor: "white",
                                padding: "8px",
                                borderRadius: "6px",
                                border: "1px solid #e0e0e0",
                                marginBottom: "8px",
                                transition: "all 0.2s ease",
                              }}
                            >
                              {/* Cabeçalho do Agendamento - AGORA SÓ COM DATA, PROFISSIONAL E EMPRESA */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                  }}
                                >
                                  {/* Informações do Agendamento */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      gap: "10px",
                                    }}
                                  >
                                    {/* Informações principais */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "3px",
                                          fontSize: "0.85rem",
                                          color: "#2c3e50",
                                        }}
                                      >
                                        <FaCalendarAlt
                                          style={{ color: "#7f8c8d" }}
                                        />
                                        <span style={{ fontWeight: "500" }}>
                                          {(() => {
                                            const data =
                                              agendamento.data_realizacao ||
                                              agendamento.data_atendimento;
                                            return data
                                              ? new Date(
                                                  data,
                                                ).toLocaleDateString("pt-BR")
                                              : "-";
                                          })()}
                                        </span>
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "3px",
                                          fontSize: "0.85rem",
                                          color: "#2c3e50",
                                        }}
                                      >
                                        <FaTag style={{ color: "#7f8c8d" }} />
                                        <span style={{ fontWeight: "500" }}>
                                          {agendamento.agendamento_id}
                                        </span>
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "3px",
                                          fontSize: "0.85rem",
                                          color: "#2c3e50",
                                        }}
                                      >
                                        <FaUserMd
                                          style={{ color: "#7f8c8d" }}
                                        />
                                        <span style={{ fontWeight: "500" }}>
                                          {agendamento.profissional_nome}
                                        </span>
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "3px",
                                          fontSize: "0.85rem",
                                          color: "#2c3e50",
                                        }}
                                      >
                                        <FaMapMarkerAlt
                                          style={{ color: "#7f8c8d" }}
                                        />
                                        <span style={{ fontWeight: "500" }}>
                                          {agendamento.empresa_nome}
                                        </span>
                                      </div>
                                    </div>

                                    {/* Botão Expandir */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <Button
                                        icon={
                                          isExpandido
                                            ? "pi pi-chevron-up"
                                            : "pi pi-chevron-down"
                                        }
                                        className="p-button-text p-button-sm"
                                        onClick={() =>
                                          alternarDetalhes(
                                            `agendamento_${agendamento.agendamento_id}`,
                                          )
                                        }
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          color: "#495057",
                                          backgroundColor: isExpandido
                                            ? "#f0f0f0"
                                            : "transparent",
                                          outline: "none",
                                          boxShadow: "none",
                                          borderRadius: "4px",
                                          border: "1px solid #dee2e6",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Detalhes Expandidos */}
                              {isExpandido && (
                                <div
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "6px",
                                    border: "1px solid #e0e0e0",
                                    marginTop: "10px",
                                    animation: "fadeIn 0.3s ease",
                                  }}
                                >
                                  {/* SERVIÇO PRINCIPAL - AGORA AQUI EM CIMA DOS SERVIÇOS EXTRAS */}
                                  <div style={{ marginBottom: "10px" }}>
                                    <div
                                      style={{
                                        fontSize: "0.8rem",
                                        color: "#7f8c8d",
                                        marginBottom: "4px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Serviço Principal:
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "#e8f5e9",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        color: "#2c3e50",
                                        border: "1px solid #c8e6c9",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
                                      }}
                                    >
                                      {agendamento.servico_descricao}
                                    </div>
                                  </div>

                                  {/* Serviços Extras (compartilhados) */}
                                  <div style={{ marginBottom: "10px" }}>
                                    {agendamento.servicos_extras &&
                                      agendamento.servicos_extras.length >
                                        0 && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "0.8rem",
                                              color: "#7f8c8d",
                                              marginBottom: "4px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            Serviços Extras:
                                          </div>
                                          <div
                                            style={{
                                              backgroundColor: "white",
                                              padding: "0",
                                              borderRadius: "6px",
                                              border: "1px solid #e0e0e0",
                                              overflow: "hidden",
                                            }}
                                          >
                                            {agendamento.servicos_extras.map(
                                              (servico, index) => (
                                                <div
                                                  key={servico.id || index}
                                                  style={{
                                                    padding: "6px 12px",
                                                    borderBottom:
                                                      index <
                                                      agendamento
                                                        .servicos_extras
                                                        .length -
                                                        1
                                                        ? "1px solid #f0f0f0"
                                                        : "none",
                                                    backgroundColor:
                                                      index % 2 === 0
                                                        ? "#fafafa"
                                                        : "white",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      alignItems: "flex-start",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        fontWeight: "600",
                                                        fontSize: "0.85rem",
                                                        color: "#2c3e50",
                                                      }}
                                                    >
                                                      {servico.descricao}
                                                    </div>
                                                  </div>
                                                </div>
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>

                                  {/* Queixas */}
                                  {agendamento.queixas && (
                                    <div style={{ marginBottom: "10px" }}>
                                      <div
                                        style={{
                                          fontSize: "0.8rem",
                                          color: "#7f8c8d",
                                          marginBottom: "4px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        Queixas:
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor: "#fff8e1",
                                          padding: "6px 12px",
                                          borderRadius: "6px",
                                          fontSize: "0.85rem",
                                          lineHeight: "1.5",
                                          whiteSpace: "pre-wrap",
                                          border: "1px solid #ffecb3",
                                        }}
                                      >
                                        {agendamento.queixas}
                                      </div>
                                    </div>
                                  )}

                                  {/* Procedimentos Individuais por Dente */}
                                  <div style={{ marginBottom: "10px" }}>
                                    <div
                                      style={{
                                        fontSize: "0.8rem",
                                        color: "#7f8c8d",
                                        marginBottom: "4px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Dentes Tratados:
                                    </div>
                                    {agendamento.procedimentos.map(
                                      (proc, idx) => (
                                        <div
                                          key={proc.procedimento_id || idx}
                                          style={{
                                            backgroundColor: "white",
                                            padding: "6px 12px",
                                            borderRadius: "6px",
                                            marginBottom: "4px",
                                            border: "1px solid #e0e0e0",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <FaTooth
                                              style={{
                                                color: "#7f8c8d",
                                                fontSize: "0.8rem",
                                              }}
                                            />
                                            <span
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "0.85rem",
                                                color: "#2c3e50",
                                              }}
                                            >
                                              {proc.dentes || "Nenhum dente"}
                                            </span>
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "0.8rem",
                                              color: "#34495e",
                                              lineHeight: "1.5",
                                              marginLeft: "20px",
                                            }}
                                          >
                                            {proc.procedimento_descricao ||
                                              proc.condicao ||
                                              "Sem descrição informada"}
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </div>

                                  {/* Observações (compartilhadas) */}
                                  {agendamento.procedimento_observacoes && (
                                    <div style={{ marginBottom: "10px" }}>
                                      <div
                                        style={{
                                          fontSize: "0.8rem",
                                          color: "#7f8c8d",
                                          marginBottom: "4px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        Observações:
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor: "#fff8e1",
                                          padding: "6px 12px",
                                          borderRadius: "6px",
                                          fontSize: "0.85rem",
                                          lineHeight: "1.5",
                                          whiteSpace: "pre-wrap",
                                          border: "1px solid #ffecb3",
                                        }}
                                      >
                                        {agendamento.procedimento_observacoes}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Botão Fechar */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                label="FECHAR"
                icon="pi pi-times"
                onClick={() => setVisibleHistorico(false)}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "6px 20px",
                  minWidth: "100px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog Financeiro */}
      <Dialog
        visible={visibleFinanceiro}
        style={{
          width: "90vw",
          maxWidth: "920px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleFinanceiro(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaChartLine style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  HISTÓRICO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  FINANCEIRO
                </div>
              </div>
              <div
                style={{
                  padding: "0 20px",
                }}
              >
                <Button
                  icon="pi pi-cart-plus"
                  onClick={() => {
                    setVisibleAdicionarSaldo(true);
                  }}
                  className="p-button-outlined p-button-sm"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    padding: "8px 24px",
                    minWidth: "40px",
                    borderColor: "#dee2e6",
                    color: "#495057",
                    fontWeight: "500",
                    fontSize: "0.875rem",
                  }}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        }
      >
        {pacienteEditando && pacienteCaixa && (
          <>
            {/* Formulário em Cards */}
            <div style={{ padding: "10px 0" }}>
              {/* 1ª Linha - Informações do Paciente */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                {/* Card Informações do Paciente */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498db",
                      }}
                    >
                      <FaUser
                        style={{ color: "#3498db", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Informações do Paciente
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        fontSize: "0.9rem",
                        color: "#34495e",
                      }}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Nome:
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {pacienteEditando.nome}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          CPF:
                        </span>
                        <span>{pacienteEditando.cpf}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Telefone:
                        </span>
                        <span>{pacienteEditando.telefone}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Email:
                        </span>
                        <span>{pacienteEditando.email}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Estatísticas Financeiras */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #9b59b6",
                      }}
                    >
                      <FaChartBar
                        style={{ color: "#9b59b6", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Estatísticas Financeiras
                      </span>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "5px",
                      }}
                    >
                      {/* Quadro Atendimentos */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaDollarSign
                            style={{ color: "#3498db", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Crédito Paciente
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#3498db",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          R$ {saldo} {/* .toFixed(2)  */}
                        </div>
                      </div>

                      {/* Quadro Carteira */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaWallet
                            style={{ color: "#e74c3c", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Carteira
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#e74c3c",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          R$ {calcularCarteira().toFixed(2)}
                        </div>
                      </div>

                      {/* Quadro Atend. Pendentes*/}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaClock
                            style={{ color: "#f39c12", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Atend. Pendentes
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#f39c12",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {
                            pacienteCaixa.filter(
                              (p) =>
                                p.caixa_status === "aberto" &&
                                p.status === "realizado",
                            ).length
                          }
                        </div>
                      </div>

                      {/* Quadro Vlr. Pendentes */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaMoneyBillAlt
                            style={{ color: "#856404", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Vlr. Pendentes
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#856404",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          R$ {calcularVlrPendentes().toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2ª Linha - Resumo Financeiro */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2ecc71",
                      }}
                    >
                      <FaChartPie
                        style={{ color: "#2ecc71", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Resumo Financeiro
                      </span>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(150px, 1fr))",
                        gap: "10px",
                      }}
                    >
                      {/* RECEITA BRUTA */}
                      <div
                        style={{
                          backgroundColor: "#e7f3ff",
                          border: "2px solid #3498db",
                          borderRadius: "6px",
                          padding: "12px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <FaMoneyBillWave
                            style={{ color: "#3498db", fontSize: "0.9rem" }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              fontWeight: "600",
                              color: "#3498db",
                            }}
                          >
                            RECEITA BRUTA
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "bold",
                            color: "#3498db",
                          }}
                        >
                          {calcularReceitaBruta()}
                        </div>
                      </div>

                      {/* DESCONTOS */}
                      <div
                        style={{
                          backgroundColor: "#ffeaea",
                          border: "2px solid #e74c3c",
                          borderRadius: "6px",
                          padding: "12px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <FaMinusCircle
                            style={{ color: "#e74c3c", fontSize: "0.9rem" }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              fontWeight: "600",
                              color: "#e74c3c",
                            }}
                          >
                            DESCONTOS
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "bold",
                            color: "#e74c3c",
                          }}
                        >
                          {calcularTotalDescontos()}
                        </div>
                      </div>

                      {/* ACRÉSCIMOS */}
                      <div
                        style={{
                          backgroundColor: "#fef9e7",
                          border: "2px solid #f39c12",
                          borderRadius: "6px",
                          padding: "12px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <FaPlusCircle
                            style={{ color: "#f39c12", fontSize: "0.9rem" }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              fontWeight: "600",
                              color: "#f39c12",
                            }}
                          >
                            ACRÉSCIMOS
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "bold",
                            color: "#f39c12",
                          }}
                        >
                          {calcularTotalAcrescimos()}
                        </div>
                      </div>

                      {/* RECEITA LÍQUIDA */}
                      <div
                        style={{
                          backgroundColor: "#e6f7ed",
                          border: "2px solid #2ecc71",
                          borderRadius: "6px",
                          padding: "12px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <FaChartLine
                            style={{ color: "#2ecc71", fontSize: "0.9rem" }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              fontWeight: "600",
                              color: "#2ecc71",
                            }}
                          >
                            RECEITA LÍQUIDA
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "bold",
                            color: "#2ecc71",
                          }}
                        >
                          {calcularReceitaLiquida()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 3ª Linha - Histórico de Faturamento */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #9b59b6",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <FaHistory
                          style={{ color: "#9b59b6", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Histórico de Faturamento (
                          {
                            pacienteCaixa.filter(
                              (item) => item.caixa_status === "fechado",
                            ).length
                          }
                          )
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                        borderRadius: "4px",
                        border: "1px solid #e8e8e8",
                      }}
                    >
                      <DataTable
                        value={historicoPagamentos}
                        stripedRows
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.85rem",
                          minWidth: "800px",
                        }}
                        emptyMessage={
                          <div
                            style={{
                              padding: "20px",
                              textAlign: "center",
                              color: "#7f8c8d",
                            }}
                          >
                            <FaDollarSign
                              style={{
                                fontSize: "2rem",
                                color: "#adb5bd",
                                marginBottom: "10px",
                                opacity: 0.5,
                              }}
                            />
                            <div style={{ fontSize: "0.9rem" }}>
                              Nenhum faturamento encontrado para este paciente
                            </div>
                          </div>
                        }
                        size="small"
                      >
                        <Column
                          header="AG"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {rowData.caixa_id}
                            </div>
                          )}
                        />
                        <Column
                          header="DATA"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {new Date(
                                rowData.pagamento_data,
                              ).toLocaleDateString("pt-BR")}
                            </div>
                          )}
                        />
                        <Column
                          header="EMPRESA"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {rowData.empresa_nome}
                            </div>
                          )}
                        />
                        <Column
                          header="PROFISSIONAL"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {rowData.profissional_nome}
                            </div>
                          )}
                        />
                        <Column
                          header="VALOR PAGO"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "500", color: "#2c3e50" }}
                            >
                              R${" "}
                              {Number(rowData.pagamento_valor || 0).toFixed(2)}
                            </div>
                          )}
                        />
                        <Column
                          header="FORMA PAG."
                          body={(rowData) => {
                            const cores = {
                              Dinheiro: { cor: "#27AE60", bg: "#EAFAF1" },
                              "Cartão de Crédito": {
                                cor: "#3498DB",
                                bg: "#E7F3FF",
                              },
                              "Cartão de Débito": {
                                cor: "#2980B9",
                                bg: "#E3F2FD",
                              },
                              Carteira: { cor: "#9B59B6", bg: "#F3E8FF" },
                              PIX: { cor: "#32CD32", bg: "#F0FFF0" },
                              Transferência: { cor: "#8E44AD", bg: "#F5EEF8" },
                              Boleto: { cor: "#D35400", bg: "#FEF5E7" },
                              Cheque: { cor: "#D68910", bg: "#FEF9E7" },
                              Depósito: { cor: "#2471A3", bg: "#EAF2F8" },
                              default: { cor: "#7F8C8D", bg: "#F8F9F9" },
                            };

                            const formaPagamento =
                              rowData.pagamento_forma || "Não informado";
                            const estilo =
                              cores[formaPagamento] || cores.default;

                            return (
                              <div
                                style={{
                                  backgroundColor: estilo.bg,
                                  color: estilo.cor,
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontWeight: "700",
                                  fontSize: "0.8rem",
                                  textAlign: "center",
                                  border: `1px solid ${estilo.cor}30`,
                                  minWidth: "90px",
                                }}
                              >
                                {formaPagamento}
                              </div>
                            );
                          }}
                        />
                        <Column
                          header="AÇÃO"
                          body={(rowData) => {
                            const semPermissao = !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            );

                            const pagamentoCarteira =
                              rowData.pagamento_forma === "Carteira";

                            const disabled = semPermissao || pagamentoCarteira;

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  icon="pi pi-print"
                                  tooltip={
                                    pagamentoCarteira
                                      ? "Recibos de carteira não podem ser impressos"
                                      : "Imprimir"
                                  }
                                  tooltipOptions={{ position: "top" }}
                                  disabled={disabled}
                                  onClick={() => {
                                    if (!disabled) {
                                      handleImprimirRecibo(rowData);
                                    }
                                  }}
                                  className="p-button-success p-button-sm"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "6px",
                                    opacity: disabled ? 0.4 : 1,
                                    cursor: disabled
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                />
                              </div>
                            );
                          }}
                        />
                      </DataTable>
                    </div>

                    {isMobile && (
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "0.75rem",
                          color: "#95a5a6",
                          padding: "8px",
                          fontStyle: "italic",
                        }}
                      >
                        ← arraste para ver mais →
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Botão Fechar */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                label="FECHAR"
                icon="pi pi-times"
                onClick={() => setVisibleFinanceiro(false)}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "6px 20px",
                  minWidth: "100px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog Carteira */}
      <Dialog
        visible={visibleCarteira}
        style={{
          width: "90vw",
          maxWidth: "920px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleCarteira(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaWallet style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  CARTEIRA DO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PACIENTE
                </div>
              </div>
            </div>
          </div>
        }
      >
        {pacienteEditando && pacienteCaixa && (
          <>
            {/* Formulário em Cards */}
            <div style={{ padding: "10px 0" }}>
              {/* 1ª Linha - Informações do Paciente */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                {/* Card Informações do Paciente */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498db",
                      }}
                    >
                      <FaUser
                        style={{ color: "#3498db", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Informações do Paciente
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        fontSize: "0.9rem",
                        color: "#34495e",
                      }}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Nome:
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {pacienteEditando.nome}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          CPF:
                        </span>
                        <span>{pacienteEditando.cpf}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Telefone:
                        </span>
                        <span>{pacienteEditando.telefone}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Email:
                        </span>
                        <span>{pacienteEditando.email}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Resumo da Carteira */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #e74c3c",
                      }}
                    >
                      <FaWallet
                        style={{ color: "#e74c3c", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Resumo da Carteira
                      </span>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "5px",
                      }}
                    >
                      {/* Quadro Atendimentos */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaFileMedical
                            style={{ color: "#3498db", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Atendimentos
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#3498db",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {
                            pacienteCaixa.filter(
                              (p) => p.caixa_status === "fechado",
                            ).length
                          }
                        </div>
                      </div>
                      {/* Quadro Atend. Pendentes*/}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          border: "1px solid #e0e0e0",
                          borderRadius: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaClock
                            style={{ color: "#f39c12", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Pendentes
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#f39c12",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          {contarPagamentosCarteira()}
                        </div>
                      </div>
                      {/* Quadro Valor Pago*/}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          border: "1px solid #e0e0e0",
                          borderRadius: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaCheckCircle
                            style={{ color: "#27ae60", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                            }}
                          >
                            Valor Pago
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#27ae60",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          R$ {calcularValorPago().toFixed(2)}
                        </div>
                      </div>
                      {/* Quadro Vlr. Pendentes */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          backgroundColor: "#fff",
                          border: "1px solid #e0e0e0",
                          borderRadius: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <FaExclamationTriangle
                            style={{ color: "#e74c3c", fontSize: "0.8rem" }}
                          />
                          <span
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                            }}
                          >
                            Pendente
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#e74c3c",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            lineHeight: "1",
                          }}
                        >
                          R$ {calcularPendenteCarteira().toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2ª Linha - Histórico da Carteira */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #e74c3c",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <FaHistory
                          style={{ color: "#e74c3c", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Histórico de Carteira ({contarPagamentosCarteira()})
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                        borderRadius: "4px",
                        border: "1px solid #e8e8e8",
                      }}
                    >
                      <DataTable
                        value={pagamentosCarteira}
                        stripedRows
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.85rem",
                          minWidth: "800px",
                        }}
                        emptyMessage={
                          <div
                            style={{
                              padding: "20px",
                              textAlign: "center",
                              color: "#7f8c8d",
                            }}
                          >
                            <FaDollarSign
                              style={{
                                fontSize: "2rem",
                                color: "#adb5bd",
                                marginBottom: "10px",
                                opacity: 0.5,
                              }}
                            />
                            <div style={{ fontSize: "0.9rem" }}>
                              Nenhum faturamento em carteira para este paciente
                            </div>
                          </div>
                        }
                        size="small"
                      >
                        <Column
                          header="ID"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {rowData.caixa_id}
                            </div>
                          )}
                        />
                        <Column
                          header="DATA"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {new Date(
                                rowData.pagamento_data,
                              ).toLocaleDateString("pt-BR")}
                            </div>
                          )}
                        />
                        <Column
                          header="EMPRESA"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {rowData.empresa_nome}
                            </div>
                          )}
                        />
                        <Column
                          header="PROFISSIONAL"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {rowData.profissional_nome}
                            </div>
                          )}
                        />
                        <Column
                          header="VALOR PAGO"
                          body={(rowData) => (
                            <div
                              style={{ fontWeight: "500", color: "#2c3e50" }}
                            >
                              R${" "}
                              {Number(rowData.pagamento_valor || 0).toFixed(2)}
                            </div>
                          )}
                        />
                        <Column
                          header="FORMA PAG."
                          body={(rowData) => {
                            const cores = {
                              Dinheiro: { cor: "#27AE60", bg: "#EAFAF1" },
                              "Cartão de Crédito": {
                                cor: "#3498DB",
                                bg: "#E7F3FF",
                              },
                              "Cartão de Débito": {
                                cor: "#2980B9",
                                bg: "#E3F2FD",
                              },
                              Carteira: { cor: "#9B59B6", bg: "#F3E8FF" },
                              PIX: { cor: "#32CD32", bg: "#F0FFF0" },
                              Transferência: { cor: "#8E44AD", bg: "#F5EEF8" },
                              Boleto: { cor: "#D35400", bg: "#FEF5E7" },
                              Cheque: { cor: "#D68910", bg: "#FEF9E7" },
                              Depósito: { cor: "#2471A3", bg: "#EAF2F8" },
                              default: { cor: "#7F8C8D", bg: "#F8F9F9" },
                            };

                            const formaPagamento =
                              rowData.pagamento_forma || "Não informado";
                            const estilo =
                              cores[formaPagamento] || cores.default;

                            return (
                              <div
                                style={{
                                  backgroundColor: estilo.bg,
                                  color: estilo.cor,
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontWeight: "700",
                                  fontSize: "0.8rem",
                                  textAlign: "center",
                                  border: `1px solid ${estilo.cor}30`,
                                  minWidth: "90px",
                                }}
                              >
                                {formaPagamento}
                              </div>
                            );
                          }}
                        />
                        <Column
                          header="AÇÃO"
                          body={(rowData) => (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Button
                                icon="pi pi-shopping-cart"
                                tooltip="Realizar pagamento"
                                tooltipOptions={{ position: "top" }}
                                onClick={() => {
                                  if (
                                    user.tipo === "administrator" ||
                                    user.modulos?.Pacientes?.editar
                                  ) {
                                    setPagamentoSelecionado(rowData);
                                    setVisibleCarteira(false);
                                    setVisibleCaixa(true);
                                  }
                                }}
                                disabled={
                                  !(
                                    user.tipo === "administrator" ||
                                    user.modulos?.Pacientes?.editar
                                  )
                                }
                                className="p-button-success p-button-sm"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "6px",
                                  opacity:
                                    user.tipo === "administrator" ||
                                    user.modulos?.Pacientes?.editar
                                      ? 1
                                      : 0.4,
                                  cursor:
                                    user.tipo === "administrator" ||
                                    user.modulos?.Pacientes?.editar
                                      ? "pointer"
                                      : "not-allowed",
                                }}
                              />
                            </div>
                          )}
                        />
                      </DataTable>
                    </div>

                    {isMobile && (
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "0.75rem",
                          color: "#95a5a6",
                          padding: "8px",
                          fontStyle: "italic",
                        }}
                      >
                        ← arraste para ver mais →
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Botão Fechar */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                label="FECHAR"
                icon="pi pi-times"
                onClick={() => setVisibleCarteira(false)}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "6px 20px",
                  minWidth: "100px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog Anexos */}
      <Dialog
        visible={visibleAnexos}
        style={{
          width: "90vw",
          maxWidth: "920px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleAnexos(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaPaperclip style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ANEXOS DO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PACIENTE
                </div>
              </div>
            </div>
          </div>
        }
      >
        {pacienteEditando && (
          <>
            {/* Formulário em Cards */}
            <div style={{ padding: "10px 0" }}>
              {/* 1ª Linha - Informações do Paciente */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                {/* Card Informações do Paciente */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498db",
                      }}
                    >
                      <FaUser
                        style={{ color: "#3498db", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Informações do Paciente
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        fontSize: "0.9rem",
                        color: "#34495e",
                      }}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Nome:
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {pacienteEditando.nome}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          CPF:
                        </span>
                        <span>{pacienteEditando.cpf}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Telefone:
                        </span>
                        <span>{pacienteEditando.telefone}</span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Email:
                        </span>
                        <span>{pacienteEditando.email}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Camera */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    {/* Container da câmera/foto com altura fixa para evitar movimento */}
                    <div
                      style={{
                        minHeight: "240px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "6px",
                        overflow: "hidden",
                      }}
                    >
                      {!fotoBase64 ? (
                        <Webcam
                          ref={webcamRef}
                          audio={false}
                          screenshotFormat="image/jpeg"
                          videoConstraints={{
                            facingMode: tipoCamera,
                            width: 1280,
                            height: 720,
                          }}
                          style={{ width: "100%", borderRadius: 6 }}
                        />
                      ) : (
                        <img
                          src={fotoBase64}
                          alt="captura"
                          style={{
                            width: "100%",
                            borderRadius: 6,
                            maxHeight: "300px",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  {/* Botões da câmera - condicional baseado no estado da foto */}
                  {!fotoBase64 ? (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      <Button
                        icon="pi pi-camera"
                        onClick={tirarFoto}
                        className="p-button-outlined p-button-sm p-button"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "25px",
                          height: "25px",
                          borderColor: "#dee2e6",
                          color: "#495057",
                        }}
                        tooltip="Tirar Foto"
                        tooltipOptions={{ position: "top" }}
                        disabled={loading}
                      />
                      <Button
                        icon="pi pi-sync"
                        onClick={alternarCamera}
                        className="p-button-outlined p-button-sm p-button"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "25px",
                          height: "25px",
                          borderColor: "#dee2e6",
                          color: "#495057",
                        }}
                        tooltip={
                          tipoCamera === "environment"
                            ? "Câmera Traseira"
                            : "Câmera Frontal"
                        }
                        tooltipOptions={{ position: "top" }}
                        disabled={loading}
                      />
                    </div>
                  ) : (
                    /* Botões de ação e observação quando a foto é tirada */
                    <div
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {/* Botões de ação */}
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          label="CANCELAR"
                          icon="pi pi-times"
                          onClick={() => setFotoBase64(null)}
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            padding: "8px 24px",
                            minWidth: "120px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            fontWeight: "500",
                            fontSize: "0.875rem",
                          }}
                          disabled={loading}
                        />
                        <Button
                          label="ENVIAR"
                          icon="pi pi-check"
                          onClick={() =>
                            handleUploadArquivo(
                              dataURLtoFile(fotoBase64, "foto.jpg"),
                            )
                          }
                          className="p-button-success p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            padding: "8px 24px",
                            minWidth: "180px",
                            fontWeight: "500",
                            fontSize: "0.875rem",
                            backgroundColor: "#27ae60",
                            borderColor: "#27ae60",
                          }}
                          loading={loading}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* 2ª Linha */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                {/* Card Galeria ou Visualizador */}
                {!fotoVisualizando ? (
                  /* CARD GALERIA */
                  <div
                    style={{
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498db",
                        }}
                      >
                        <FaImage
                          style={{ color: "#3498db", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Galeria de Imagens
                        </span>

                        {/* Botão para atualizar galeria */}
                        <Button
                          icon="pi pi-refresh"
                          onClick={() =>
                            handleCarregarFotosPaciente(pacienteEditando.id)
                          }
                          className="p-button-outlined p-button-sm p-button"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            background: "#3498DB",
                            color: "white",
                            marginLeft: "auto",
                          }}
                          tooltip="Atualizar galeria"
                          tooltipOptions={{ position: "top" }}
                          disabled={loading}
                        />
                      </div>

                      {/* Grid de fotos */}
                      {loading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <i
                            className="pi pi-spin pi-spinner"
                            style={{ fontSize: "2rem", color: "#3498db" }}
                          ></i>
                          <p>Carregando fotos...</p>
                        </div>
                      ) : fotosPaciente.length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "30px 20px",
                            backgroundColor: "#f5f5f5",
                            borderRadius: "8px",
                            color: "#7f8c8d",
                          }}
                        >
                          <FaImage
                            style={{
                              fontSize: "3rem",
                              opacity: 0.3,
                              marginBottom: "10px",
                            }}
                          />
                          <p>Nenhuma foto encontrada</p>
                          <p style={{ fontSize: "0.85rem" }}>
                            Tire uma foto usando a câmera
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(120px, 1fr))",
                            gap: "10px",
                            maxHeight: "400px",
                            overflowY: "auto",
                            padding: "5px",
                          }}
                        >
                          {fotosPaciente.map((foto) => {
                            const imagemSrc = imagensCarregadas[foto.id];

                            return (
                              <div
                                key={foto.id}
                                style={{
                                  position: "relative",
                                  borderRadius: "6px",
                                  overflow: "hidden",
                                  border: "1px solid #e0e0e0",
                                  aspectRatio: "4/3",
                                  cursor: "pointer",
                                  transition: "transform 0.2s",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.transform =
                                    "scale(1.02)")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.transform = "scale(1)")
                                }
                                onClick={() => abrirVisualizadorFoto(foto)}
                              >
                                {imagemSrc ? (
                                  <img
                                    src={imagemSrc}
                                    alt={foto.observacao || `Foto ${foto.id}`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      background: "#f0f0f0",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#999",
                                      fontSize: "0.8rem",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                  >
                                    <i
                                      className="pi pi-spin pi-spinner"
                                      style={{ fontSize: "1.5rem" }}
                                    ></i>
                                    <span>Carregando...</span>
                                  </div>
                                )}

                                {/* Overlay com informações */}
                                <div
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    background:
                                      "linear-gradient(transparent, rgba(0,0,0,0.7))",
                                    color: "white",
                                    padding: "5px",
                                    fontSize: "0.7rem",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    zIndex: 2,
                                  }}
                                >
                                  <span>{foto.data_formatada}</span>
                                  <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-sm"
                                    style={{
                                      color: "white",
                                      width: "20px",
                                      height: "20px",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (
                                        window.confirm(
                                          "Tem certeza que deseja excluir esta foto?",
                                        )
                                      ) {
                                        handleDeletarFoto(foto.id);
                                      }
                                    }}
                                    tooltip="Excluir foto"
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  /* VISUALIZADOR DE FOTO */
                  <div
                    style={{
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {/* Cabeçalho do visualizador */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #e67e22",
                        }}
                      >
                        <FaEye
                          style={{ color: "#e67e22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Visualizando Foto
                        </span>

                        {/* Botão voltar */}
                        <Button
                          icon="pi pi-arrow-left"
                          className="p-button p-button-rounded p-button-warning"
                          onClick={fecharVisualizadorFoto}
                          tooltip="Voltar para galeria"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "30px",
                            height: "30px",
                            marginLeft: "auto",
                          }}
                        />
                      </div>

                      {/* Imagem em tamanho maior */}
                      <div
                        style={{
                          backgroundColor: "#f0f0f0",
                          borderRadius: "6px",
                          padding: "10px",
                          textAlign: "center",
                          minHeight: "300px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {imagemVisualizador ? (
                          <img
                            src={imagemVisualizador}
                            alt={
                              fotoVisualizando.observacao || "Foto do paciente"
                            }
                            style={{
                              maxWidth: "100%",
                              maxHeight: "400px",
                              objectFit: "contain",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              padding: "40px",
                              background: "#f0f0f0",
                              borderRadius: "6px",
                              color: "#999",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className="pi pi-spin pi-spinner"
                              style={{ fontSize: "3rem" }}
                            ></i>
                            <p>Carregando imagem...</p>
                          </div>
                        )}
                      </div>

                      {/* Informações da foto */}
                      <div
                        style={{
                          padding: "10px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "6px",
                          fontSize: "0.9rem",
                          color: "#34495e",
                        }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "auto 1fr",
                            gap: "5px 10px",
                          }}
                        >
                          <span style={{ color: "#7f8c8d" }}>Data:</span>
                          <span>
                            {fotoVisualizando.data_formatada ||
                              fotoVisualizando.data_upload}
                          </span>

                          <span style={{ color: "#7f8c8d" }}>Tamanho:</span>
                          <span>
                            {fotoVisualizando.tamanho_formatado ||
                              formatarTamanho(fotoVisualizando.tamanho)}
                          </span>

                          <span style={{ color: "#7f8c8d" }}>Tipo:</span>
                          <span>{fotoVisualizando.tipo}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Botão Fechar */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                label="FECHAR"
                icon="pi pi-times"
                onClick={() => setVisibleAnexos(false)}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "6px 20px",
                  minWidth: "100px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog ADICIONAR CRÉDITO PACIENTE*/}
      <Dialog
        visible={visibleAdicionarSaldo}
        style={{
          width: "90vw",
          maxWidth: "450px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            setValorAdicionar("");
            setEmpresa(null);
            setFormaPagamento(null);
            setVisibleAdicionarSaldo(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaCashRegister
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  CRÉDITO
                </div>
              </div>
            </div>
          </div>
        }
      >
        {pacienteEditando && pacienteCaixa && (
          <>
            <div style={{ padding: "10px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                {/* Card Paciente */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498db",
                      }}
                    >
                      <FaUser
                        style={{ color: "#3498db", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Informações do Paciente
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        fontSize: "0.9rem",
                        color: "#34495e",
                      }}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Nome:
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {pacienteEditando.nome}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Crédito:
                        </span>
                        <span style={{ fontWeight: "bold", color: "#3498DB" }}>
                          R$ {saldo}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Empresa */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #16A085",
                      }}
                    >
                      <FaBuilding
                        style={{ color: "#16A085", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Empresa *
                      </span>
                    </div>
                    <Dropdown
                      value={empresa}
                      onChange={(e) => {
                        setEmpresa(e.value);
                        buscarFormasPagamentoEmpresa(e.value);
                      }}
                      options={empresasOptions}
                      placeholder="Selecione a empresa"
                      className="p-inputtext-sm"
                      style={{
                        width: "100%",
                        height: "35px",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                      }}
                      panelStyle={{
                        fontFamily: "'Rajdhani', sans-serif",
                        fontSize: "0.9rem",
                      }}
                      itemTemplate={(option) => (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                            padding: "8px 12px",
                          }}
                        >
                          {option.label}
                        </span>
                      )}
                      valueTemplate={(option, props) => {
                        if (!option)
                          return (
                            <span
                              style={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                                color: "#7f8c8d",
                              }}
                            >
                              {props.placeholder}
                            </span>
                          );
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                            }}
                          >
                            {option.label}
                          </span>
                        );
                      }}
                      disabled={carregandoEmpresas}
                    />
                  </div>
                </div>

                {/* Card Adicionar Saldo */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #27ae60",
                      }}
                    >
                      <FaCashRegister
                        style={{ color: "#27ae60", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Adicionar Crédito ao Paciente
                      </span>
                    </div>

                    {/* Campo Valor */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#27ae60",
                          fontSize: "1.2rem",
                        }}
                      >
                        R$
                      </span>
                      <InputNumber
                        className="p-inputtext-sm"
                        value={valorAdicionar}
                        onValueChange={(e) => setValorAdicionar(e.target.value)}
                        style={{
                          width: "100px",
                          height: "40px",
                          borderRadius: "6px",
                          backgroundColor: "white",
                        }}
                        inputStyle={{
                          fontSize: "1.4rem",
                          fontFamily: "'Rajdhani', sans-serif",
                          fontWeight: "bold",
                          color: "#27ae60",
                        }}
                      />
                    </div>

                    {/* Campo Forma de Pagamento */}
                    <div>
                      <label
                        style={{
                          fontSize: "0.85rem",
                          color: "#7f8c8d",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Forma de Pagamento *
                      </label>
                      <Dropdown
                        value={formaPagamento}
                        onChange={(e) => setFormaPagamento(e.value)}
                        options={
                          formasPagamento && formasPagamento.length > 0
                            ? formasPagamento.map((fp) => ({
                                label: fp.descricao,
                                value: fp.id,
                              }))
                            : []
                        }
                        className="p-inputtext-sm"
                        placeholder="Selecione a Forma de Pagamento"
                        style={{
                          width: "100%",
                          height: "35px",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                        }}
                        panelStyle={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                        }}
                        itemTemplate={(option) => (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              padding: "8px 12px",
                            }}
                          >
                            {option.label}
                          </span>
                        )}
                        valueTemplate={(option, props) => {
                          if (!option)
                            return (
                              <span
                                style={{
                                  fontFamily: "'Rajdhani', sans-serif",
                                  fontSize: "0.9rem",
                                  color: "#7f8c8d",
                                }}
                              >
                                {props.placeholder}
                              </span>
                            );
                          return (
                            <span
                              style={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                            >
                              {option.label}
                            </span>
                          );
                        }}
                        showClear
                        disabled={
                          loading ||
                          !empresa ||
                          !formasPagamento ||
                          formasPagamento.length === 0
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Botões */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                flexWrap: "wrap",
                marginTop: "20px",
              }}
            >
              <Button
                label="CANCELAR"
                icon="pi pi-times"
                onClick={() => {
                  setValorAdicionar("");
                  setEmpresa(null);
                  setFormaPagamento(null);
                  setVisibleAdicionarSaldo(false);
                }}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "120px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
                disabled={loading}
              />
              <Button
                label={loading ? "PROCESSANDO..." : "ADICIONAR SALDO"}
                icon="pi pi-plus-circle"
                onClick={handleAdicionarSaldo}
                className="p-button-success p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "180px",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  backgroundColor: "#27ae60",
                  borderColor: "#27ae60",
                }}
                disabled={
                  loading ||
                  !valorAdicionar ||
                  parseFloat(valorAdicionar) <= 0 ||
                  !empresa ||
                  !formaPagamento
                }
                loading={loading}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog FECHAR PAGAMENTO*/}
      <Dialog
        visible={visibleCaixa}
        style={{
          width: "90vw",
          maxWidth: "480px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleCaixa(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaCashRegister
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  FECHAMENTO DE
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  CAIXA
                </div>
              </div>
            </div>
          </div>
        }
      >
        {pagamentoSelecionado && (
          <>
            {/* Formulário em Cards */}
            <div style={{ padding: "10px 0" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "15px",
                  marginBottom: "5px",
                }}
              >
                {/* Lado Esquerdo - Cards */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  {/* Card Paciente */}
                  <div
                    style={{
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498db",
                        }}
                      >
                        <FaUser
                          style={{ color: "#3498db", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Informações do Paciente
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                          fontSize: "0.9rem",
                          color: "#34495e",
                        }}
                      >
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span
                            style={{ color: "#7f8c8d", fontSize: "0.8rem" }}
                          >
                            Nome:
                          </span>
                          <span style={{ fontWeight: "500" }}>
                            {pagamentoSelecionado.paciente_nome}
                          </span>
                        </div>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span
                            style={{ color: "#7f8c8d", fontSize: "0.8rem" }}
                          >
                            Telefone:
                          </span>
                          <span>{pagamentoSelecionado.paciente_telefone}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card Valor Total*/}
                  <div
                    style={{
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #2ecc71",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FaShoppingCart
                            style={{ color: "#2ecc71", fontSize: "0.9rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "0.95rem",
                              letterSpacing: "0.3px",
                            }}
                          >
                            Valor Total
                          </span>
                        </div>
                      </div>

                      <div
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                          color: "#27ae60",
                          textAlign: "center",
                        }}
                      >
                        R${" "}
                        {parseFloat(
                          pagamentoSelecionado.pagamento_valor,
                        ).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  </div>

                  {/* Card Valor a Receber */}
                  <div
                    style={{
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #D35400",
                        }}
                      >
                        <FaCashRegister
                          style={{ color: "#D35400", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Valor a Receber
                        </span>
                      </div>

                      <div
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                          color: "#D35400",
                          textAlign: "center",
                        }}
                      >
                        R${" "}
                        {calcularValorFinal().toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  </div>

                  {/* Card Forma de Pagamento */}
                  <div
                    style={{
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #9b59b6",
                        }}
                      >
                        <FaCreditCard
                          style={{ color: "#9b59b6", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Forma de Pagamento
                        </span>
                      </div>
                      <Dropdown
                        value={tipoPagamento}
                        onChange={(e) => setTipoPagamento(e.value)}
                        options={pagamentoSelecionado.formas_pagamento_disponiveis.map(
                          (fp) => ({
                            label: fp.descricao,
                            value: fp,
                          }),
                        )}
                        placeholder="Selecione a forma de pagamento"
                        className="p-inputtext-sm"
                        style={{
                          width: "100%",
                          height: "35px",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                        }}
                        panelStyle={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                        }}
                        itemTemplate={(option) => (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              padding: "8px 12px",
                            }}
                          >
                            {option.label}
                          </span>
                        )}
                        valueTemplate={(option, props) => {
                          if (!option)
                            return (
                              <span
                                style={{
                                  fontFamily: "'Rajdhani', sans-serif",
                                  fontSize: "0.9rem",
                                  color: "#7f8c8d",
                                }}
                              >
                                {props.placeholder}
                              </span>
                            );
                          return (
                            <span
                              style={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                            >
                              {option.label}
                            </span>
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Botão Fechar */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                flexWrap: "wrap",
              }}
            >
              <Button
                label="CANCELAR"
                icon="pi pi-times"
                onClick={() => {
                  resetarCampos();
                  setVisibleCaixa(false);
                }}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "120px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
                disabled={loading}
              />
              <Button
                label={loading ? "PROCESSANDO..." : "CONFIRMAR PAGAMENTO"}
                icon="pi pi-check"
                onClick={() => handleConfirmarPagamento(pagamentoSelecionado)}
                className="p-button-success p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "180px",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  backgroundColor: "#27ae60",
                  borderColor: "#27ae60",
                }}
                disabled={loading || !tipoPagamento}
                loading={loading}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => {
              fetchPacientes();
              resetarCampos();
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={visualizacaoResumida ? "pi pi-eye" : "pi pi-eye-slash"}
            className="icon-button-titulo"
            onClick={() => {
              setVisualizacaoResumida(!visualizacaoResumida);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={mostrarFiltroPaciente ? "pi pi-filter-slash" : "pi pi-filter"}
            className="icon-button-titulo"
            onClick={() => {
              setMostrarFiltroPaciente(!mostrarFiltroPaciente);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => {
              if (
                user.tipo === "administrator" ||
                user.modulos?.Pacientes?.editar
              ) {
                setVisibleNovoPaciente(true);
                resetarCampos();
              }
            }}
            disabled={
              !(
                user.tipo === "administrator" || user.modulos?.Pacientes?.editar
              )
            }
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              opacity:
                user.tipo === "administrator" || user.modulos?.Pacientes?.editar
                  ? 1
                  : 0.4,
              cursor:
                user.tipo === "administrator" || user.modulos?.Pacientes?.editar
                  ? "pointer"
                  : "not-allowed",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
      <div style={{ flex: 1, padding: "50px 10px" }}>
        {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ marginTop: "7px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <FaUserFriends
                  style={{ color: "#B83732", fontSize: "1.2rem" }}
                />
                <h3 style={{ margin: 0, color: "#424242" }}>PACIENTES</h3>

                {/* Bolinha com quantidade */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "25px",
                    height: "25px",
                    background:
                      "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                    borderRadius: "50px",
                    padding: "0 8px",
                    margin: "0 8px",
                    boxShadow: "0 2px 4px rgba(184, 55, 50, 0.2)",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      lineHeight: 1,
                    }}
                  >
                    {pacientes.length}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText
                  className="p-inputtext-sm"
                  placeholder="Pesquisar por Nome"
                  value={filtroNome}
                  onChange={(e) => setFiltroNome(e.target.value)}
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "100%",
                    height: "30px",
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                />
              </IconField>
            </div>
          </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Filtros*/}
          {mostrarFiltroPaciente && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "920px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {/* 1ª Linha - Nome e CPF */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {/* Card Nome */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaUser
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Nome{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Nome do paciente"
                        value={filtroNome}
                        onChange={(e) => setFiltroNome(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card CPF */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #E67E22",
                        }}
                      >
                        <FaIdCard
                          style={{ color: "#E67E22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          CPF{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="CPF do paciente"
                        value={filtroCpf}
                        onChange={(e) => setFiltroCpf(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Telefone */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #2980b9",
                        }}
                      >
                        <FaPhone
                          style={{ color: "#2980b9", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Telefone
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Telefone do paciente"
                        value={filtroTelefone}
                        onChange={(e) => setFiltroTelefone(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Email */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #d35400",
                        }}
                      >
                        <FaEnvelope
                          style={{ color: "#d35400", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Email
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Email do paciente"
                        value={filtroEmail}
                        onChange={(e) => setFiltroEmail(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grids - Visualização Condicional */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {pacientesFiltrados.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaUserFriends
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhum paciente encontrado
                </h3>
              </div>
            ) : !visualizacaoResumida ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {pacientesFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px 14px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Bloco esquerdo - Paciente */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          minWidth: "260px",
                          flex: "1 1 260px",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                            borderRadius: "10px",
                            padding: "10px",
                            display: "inline-flex",
                          }}
                        >
                          <FaUser
                            style={{ fontSize: "1.5rem", color: "#fff" }}
                          />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.nome}
                          </h3>

                          {/* Info Tags */}
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "5px",
                              alignItems: "center",
                              color: "#64748b",
                              fontSize: "0.9rem",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <FaIdCard
                                style={{ fontSize: "0.7rem", color: "#64748b" }}
                              />
                              <span>{item.cpf}</span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <FaPhone
                                style={{ fontSize: "0.7rem", color: "#2980b9" }}
                              />
                              <span>{item.telefone}</span>
                            </div>

                            {item.cidade && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <FaMapMarkerAlt
                                  style={{
                                    fontSize: "0.7rem",
                                    color: "#e74c3c",
                                  }}
                                />
                                <span>{item.cidade}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Status + Ações */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: "8px",
                          flex: "1 1 320px",
                          marginLeft: "auto",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "2px 6px",
                            borderRadius: "12px",
                            fontSize: "0.75rem",
                            fontWeight: "500",
                            color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                          }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              borderRadius: "50%",
                              backgroundColor:
                                item.ativo === "1" ? "#27ae60" : "#e74c3c",
                            }}
                          />
                        </div>

                        {/* Botões de ação - manter iguais aos que você já tem */}
                        <Button
                          icon="pi pi-file-edit"
                          onClick={() => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            ) {
                              setPacienteEditando(item);

                              setNome(item.nome);
                              setCpf(item.cpf);
                              setRg(item.rg);
                              setDtNascimento(item.data_nascimento);
                              setEmail(item.email);
                              setTelefone(item.telefone);
                              setLogradouro(item.logradouro);
                              setNumero(item.numero);
                              setBairro(item.bairro);
                              setCidade(item.cidade);
                              setEstado(item.estado);
                              setCep(item.cep);
                              setAtivo(item.ativo === "1");

                              setVisibleEditar(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Editar"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-calendar-plus"
                          onClick={async () => {
                            setPacienteEditando(item);
                            await fetchTodosDados();
                            setVisibleAdicionar(true);
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Agenda"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-user-edit"
                          onClick={async () => {
                            setPacienteEditando(item);
                            await fetchDadosFicha(item.id);
                            setVisibleFicha(true);
                          }}
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Ficha"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-history"
                          onClick={async () => {
                            setPacienteEditando(item);
                            await buscarFichaPaciente(item.id);
                            setVisibleHistorico(true);
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Histórico"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-dollar"
                          onClick={async () => {
                            setPacienteEditando(item);
                            await fetchPacientesCaixas(item.id);
                            await fetchEmpresas();
                            setSaldo(item.saldo);
                            setVisibleFinanceiro(true);
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Financeiro"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-wallet"
                          onClick={async () => {
                            setPacienteEditando(item);
                            await fetchPacientesCaixas(item.id);
                            setVisibleCarteira(true);
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Carteira"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-paperclip"
                          onClick={async () => {
                            setPacienteEditando(item);
                            await handleCarregarFotosPaciente(item.id);
                            setFotoBase64(null);
                            setObservacaoFoto("");
                            setVisibleAnexos(true);
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Pacientes?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Anexos"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {pacientesFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {/* Informações do Paciente */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                            borderRadius: "10px",
                            padding: "10px",
                            display: "inline-flex",
                          }}
                        >
                          <FaUser
                            style={{ fontSize: "1.5rem", color: "#fff" }}
                          />
                        </div>

                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: "0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.nome}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                              fontSize: "0.85rem",
                            }}
                          >
                            <FaIdCard
                              style={{ fontSize: "0.7rem", color: "#64748b" }}
                            />
                            <span>{item.cpf}</span>
                          </div>
                        </div>
                      </div>

                      {/* Detalhes do Agendamento */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr",
                          gap: "6px",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaPhone
                              style={{
                                color: "#2980b9",
                                fontSize: "0.75rem",
                              }}
                            />
                            <span
                              style={{
                                fontSize: "0.8rem",
                                color: "#2c3e50",
                                fontWeight: "500",
                              }}
                            >
                              {item.telefone}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Cidade */}
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e8e8e8",
                          padding: "6px",
                          borderRadius: "6px",
                          marginBottom: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FaMapMarkerAlt
                            style={{
                              color: "#e74c3c",
                              fontSize: "0.75rem",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              color: item.cidade ? "#2c3e50" : "#95a5a6",
                              fontWeight: "500",
                            }}
                          >
                            {item.cidade || "Aguardando cadastro..."}
                          </span>
                        </div>
                      </div>

                      {/* Ações Secundárias */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        {/* Ativo */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              fontFamily: "'Rajdhani', sans-serif",
                              gap: "6px",
                              padding: "2px 6px",
                              borderRadius: "12px",
                              fontSize: "0.75rem",
                              fontWeight: "500",
                              color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                            }}
                          >
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                backgroundColor:
                                  item.ativo === "1" ? "#27ae60" : "#e74c3c",
                              }}
                            />
                          </div>
                        </div>

                        {/* Botões de ação */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          {/* Botões de ação - manter iguais aos que você já tem */}
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              ) {
                                setPacienteEditando(item);

                                setNome(item.nome);
                                setCpf(item.cpf);
                                setRg(item.rg);
                                setDtNascimento(item.data_nascimento);
                                setEmail(item.email);
                                setTelefone(item.telefone);
                                setLogradouro(item.logradouro);
                                setNumero(item.numero);
                                setBairro(item.bairro);
                                setCidade(item.cidade);
                                setEstado(item.estado);
                                setCep(item.cep);
                                setAtivo(item.ativo === "1");

                                setVisibleEditar(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Editar"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-user-edit"
                            onClick={async () => {
                              setPacienteEditando(item);
                              await fetchDadosFicha(item.paciente_id);
                              await buscarFichaPaciente(item.paciente_id);
                              setVisibleFicha(true);
                            }}
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Ficha"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-calendar-plus"
                            onClick={async () => {
                              setPacienteEditando(item);
                              await fetchTodosDados();
                              setVisibleAdicionar(true);
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Agenda"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-history"
                            onClick={async () => {
                              setPacienteEditando(item);
                              await buscarFichaPaciente(item.id);
                              setVisibleHistorico(true);
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Histórico"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-dollar"
                            onClick={async () => {
                              setPacienteEditando(item);
                              await fetchPacientesCaixas(item.id);
                              await fetchEmpresas();
                              setSaldo(item.saldo);
                              setVisibleFinanceiro(true);
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Financeiro"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-wallet"
                            onClick={async () => {
                              setPacienteEditando(item);
                              await fetchPacientesCaixas(item.id);
                              setVisibleCarteira(true);
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Carteira"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-paperclip"
                            onClick={async () => {
                              setPacienteEditando(item);
                              await handleCarregarFotosPaciente(item.id);
                              setFotoBase64(null);
                              setObservacaoFoto("");
                              setVisibleAnexos(true);
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Pacientes?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Anexos"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Loading Spinner */}
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="8"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Pacientes;
